<template>
  <div class="col-12 alternative-page">
    <div class="top-section hero-section competitor">
      <div
        v-for="letter in ['l','r', 'u', 'd']"
        :key="letter"
        :class="`${letter}-shadow`"
        class="shadow"
      />
      <div class="container">
        <div class="col-12 col">
          <div class="col-8 col sm-12 offset-2">
            <h1 class="h2">
              {{ page.data.heroSection.title }}
            </h1>
            <div class="body-1">
              {{ page.data.heroSection.subtitle }}
            </div>
          </div>
          <div class="col-10 col sm-12 offset-1">
            <div class="body-2" v-html="page.data.heroSection.description" />
          </div>
        </div>
      </div>
      <div class="wall" />
    </div>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <div class="site-section science-vs-competitor">
        <div class="container">
          <h2 class="h3 first-title">
            {{ page.data.thirdSection.title }}
          </h2>
          <div class="body-2" v-html="page.data.firstSection.text" />
          <div class="pricing-plans">
            <div class="section-inner row">
              <div class="col col-5 md-6">
                <div class="pricing-plan plan-annual plan-datascience">
                  <div class="plan-inner">
                    <div class="plan-head">
                      <Logo365 class="logo" />
                      <span class="h5 premium">Premium</span>
                      <h2>
                        {{ page.data.thirdSection.dataSciencePrice }}
                        <span class="body-1">per month</span>
                      </h2>
                      <span class="caption">
                        <span>Billed annually</span>
                      </span>
                      <div class="col-12">
                        <button class="btn-primary btn-lg" @click="subscribe">
                          Start at 57% Off
                        </button>
                      </div>
                    </div>
                  </div>
                  <ul class="plan-features">
                    <li
                      v-for="(plan, i) in page.data.thirdSection.featuredPlans"
                      :key="i"
                      class="feature"
                    >
                      <Component
                        :is="plan.dataScience ? 'IconCheck' : 'IconX'"
                        class="social-icon"
                      />
                      <span
                        :class="{ active: plan.dataScience }"
                        class="feature-label"
                      >
                        {{ plan.name }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col col-5 md-6">
                <div class="pricing-plan plan-annual plan-competitor">
                  <div class="plan-inner">
                    <div class="plan-head">
                      <Component :is="page.data.thirdSection.planHead.logo" class="logo logo-2" :class="{ 'edx': page.data.competitorName === 'edX' }" />
                      <span class="h5 premium">{{ page.data.thirdSection.planHead.planType }}</span>
                      <h2>
                        {{ page.data.thirdSection.planHead.price }}
                        <span class="body-1"> {{ page.data.thirdSection.planHead.pricePer || 'per month' }}</span>
                      </h2>
                      <span class="caption">
                        <span>{{ page.data.thirdSection.planHead.billed || 'Billed annually' }}</span>
                      </span>
                    </div>
                  </div>
                  <ul class="plan-features">
                    <li
                      v-for="(plan, i) in page.data.thirdSection.featuredPlans"
                      :key="i"
                      class="feature"
                    >
                      <Component
                        :is="plan.competitor ? 'IconCheck' : 'IconX'"
                        class="social-icon"
                      />
                      <span
                        :class="{ active: plan.competitor }"
                        class="feature-label"
                      >
                        {{ plan.name }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="row section-white">
            <div class="col col-12">
              <h2 class="h3">
                {{ page.data.firstSection.title }}
              </h2>
            </div>
            <div class="col-6 sm-6 col">
              <h2 class="h5 highlight">
                {{ page.data.firstSection.subtitle }}
              </h2>
              <div class="body-2" v-html="page.data.firstSection.dataScienceText" />
            </div>
            <div class="col-6 sm-6 col text-right">
              <img
                class="image" :src="getDataScienceImage(page.data.firstSection.dataScienceImage)" :title="page.data.firstSection.dataScienceImageTitle"
                :alt="page.data.firstSection.dataScienceImageAlt"
              >
            </div>
            <div class="col-6 sm-6 col sm-order-2">
              <img
                class="image image-2" :src="getCompetitorImage(page.data.firstSection.competitorImage)" :title="page.data.firstSection.competitorImageTitle"
                :alt="page.data.firstSection.competitorImageAlt"
              >
            </div>
            <div class="col-6 sm-6 col sm-order-1">
              <h2 class="h5 title">
                {{ page.data.competitorName }}
              </h2>
              <div class="body-2" v-html="page.data.firstSection.competitorText" />
            </div>
            <div class="col-12 col sm-order-3">
              <div class="body-2" v-html="page.data.firstSection.subText" />
            </div>
            <div class="offset-2 col-8 col sm-12 sm-order-3 holder-button">
              <div class="ready-to-learn">
                <button class="btn-primary btn-lg" @click="subscribe">
                  Start Learning at 57% Off
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Lazy>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <div class="site-section dark">
        <div class="container">
          <div class="auxiliary-services">
            <h2 class="h3">
              {{ page.data.secondSection.title }}
            </h2>
            <div v-for="(li,i) in page.data.secondSection.list" :key="i" class="col-12 col">
              <h3 class="h4">
                {{ li.name }}
              </h3>
              <div class="body-2" v-html="li.text" />
            </div>
          </div>
        </div>
      </div>
    </Lazy>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <div class="site-section white ">
        <div class="container">
          <div class="col-12">
            <h2 class="h3">
              {{ page.data.fourthSection.title }}
            </h2>
          </div>
          <div class="body-2" v-html="page.data.fourthSection.text" />
        </div>
      </div>
    </Lazy>
    <Lazy>
      <PreFooter
        title="Ready To Take The First Step?"
        description="Enroll in the training at 57% off. Get access to the full set of courses."
        button-title="Start Learning at 57% Off"
        button-link="/checkout/?plan=annual&coupon=OTH20DQT20NW4"
        class="pre-footer"
        :dark="false"
      />
    </Lazy>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Lazy from 'vue-lazy-hydration';
import HeroSection from '@itbpbg/lms-components/src/components/HeroSection';
import PreFooter from '../components/PreFooter';
import IconCheck from '../assets/svg/icon-check-accent.svg?vue-component';
import IconX from '../assets/svg/icon-close-gray.svg?vue-component';
import Logo365 from '../assets/svg/365-logo.svg?vue-component';
import LogoDataQuest from '../assets/svg/dataquest-logo.svg?vue-component';
import LogoCoursera from '../assets/svg/coursera-logo.svg?vue-component';
import LogoDataCamp from '../assets/svg/datacamp-logo.svg?vue-component';
import LogoCodeAcademy from '../assets/svg/codeacademy-logo.svg?vue-component';
import LogoLinkedIn from '../assets/svg/linkedIn-learning-logo.svg?vue-component';
import LogoPluralSight from '../assets/svg/pluralsight-logo.svg?vue-component';
import LogosSringboard from '../assets/svg/springboard-logo.svg?vue-component';
import LogoTreehouse from '../assets/svg/treehouse-logo.svg?vue-component';
import LogoEdx from '../assets/svg/edx-logo.svg?vue-component';
import LogoSimplilearn from '../assets/svg/simplilearn-logo.svg?vue-component';
import LogoCFI from '../assets/svg/cfi-logo.svg?vue-component';

export default {
  components: {
    Lazy,
    PreFooter,
    IconCheck,
    IconX,
    Logo365,
    LogoDataQuest,
    HeroSection,
    LogoCoursera,
    LogoDataCamp,
    LogoCodeAcademy,
    LogoLinkedIn,
    LogoPluralSight,
    LogosSringboard,
    LogoTreehouse,
    LogoEdx,
    LogoSimplilearn,
    LogoCFI,
  },
  mixins: [global],
  props: {
    seo: { type: Object, required: true },
  },
  data() {
    return {
      data: {
        '/365datascience-coursera-alternative/': {
          competitorName: 'Coursera',
          heroSection: {
            title: 'Coursera Alternative: 365 Data Science vs Coursera',
            subtitle: 'Why 365 Data Science Brings More Value to Beginner Data Science Students Course Content, Features, Pricing',
            description: 'Are you searching for a <strong>Coursera alternative</strong>? Coursera is one of the world’s leading e-learning platforms, with over 92 million students and 7,000+ courses. While Coursera does have a more extensive global reach and a significantly larger library of online courses, novice data scientists may find the more personalized and focused approach of 365 Data Science to suit their learning needs best.<br><br> Here is how the value proposition of the 365 Data Science program differs from Coursera’s.',
          },
          firstSection: {
            title: 'The Course Content: 365 Data Science vs Coursera',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. Its course curriculum is designed systematically and structured to allow you to build a solid foundation and understand more complicated topics later.',
            subtitle: '365 Data Science',
            dataScienceText: '<strong>365 Data Science</strong> offers <strong>three career tracks:</strong> Data Scientist, Data Analyst, and Business Analyst. Each track starts with Intro to Data and Data Science – a course that comprehensively describes Business Intelligence (BI) and Data Science. All the Career Tracks teach fundamental and essential statistical concepts required for data analysis. In contrast, the Data Science career track further expands on those skills with advanced probability concepts necessary for you to think like a data scientist.<br><br>What makes 365 Data Science particularly suitable for novice users is that each course is a natural continuation of the previous ones and considers the skill level already reached. You won’t need to repeat the same explanations because the course authors were unsure whether a given concept had been taught in previous courses. The program features world-class instructors who have gained working experience with such firms as (among others) Meta, Google, Spotify, Ikea, and Henkel.',
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: 'The <strong>Coursera library</strong> offers a <strong>colossal variety</strong> of over 7,000+ courses in (among others) Science, Business, Programming, Health, Personal Development, and Language Learning—most of which are taught by top universities and organizations. With over 2,500+ options for learning data science, Coursera can be <strong>overwhelming for a novice data scientist</strong> who doesn’t understand the logical progression of their career path.<br><br>Most <strong>Coursera data science courses</strong> follow one of <strong>two tracks, </strong>including 1) Specialization, a series of related <strong>Coursera data science specialization</strong> courses that help you master a specific topic, and 2) a Professional Certificate that enables you to become job-ready in a particular field.<br><br> <strong>Each track consists of four to six courses.</strong> And if you have concrete career goals, Coursera provides an excellent way to earn credentials recognized by the company you’re interested in.',
            competitorImage: 'coursera-img2.jpg',
            competitorImageAlt: 'Screenshot from Coursera library’s learning platform displaying part of its course content.',
            competitorImageTitle: 'Coursera library Learning Platform',
            subText: '365 Data Science and Coursera cover all the essential software tools (Python, SQL, R, Excel, Power BI, and Tableau) that aspiring data scientists, data analysts, and business analysts need to know to become data professionals.',
          },
          secondSection: {
            title: 'Key Features: 365 Data Science vs Coursera',
            list: [
              {
                name: 'Learning Platform',
                text: '<span class="highlight">365 Data Science</span> recognizes the challenges students face when learning data science online. So, to address any apprehension, we incorporated game design features that make the whole experience fun and engaging.<br><br> All aspects of the 365 platform are designed to support and motivate students to build positive learning habits, which are rewarded with various benefits. In addition to the standard dashboard—where you set goals and track your progress—it also offers an XP system, leaderboard, news feed, collectible cards, and much more.<br><br><strong>The Coursera platform,</strong> on the other hand, doesn’t offer gamified elements and lacks the features to engage and encourage students to study daily. But it does allow you to track your progress for each course and set weekly learning goals.',
              },
              {
                name: 'Learning materials',
                text: '365 Data Science and Coursera combine comprehensive video lessons taught by industry-recognized professionals with downloadable resources to supplement your learning.<br><br> <strong>Coursera</strong> allows you to download the video lectures as mp4 files, accessible offline at any time. Perhaps one of their strongest points is the downloadable video transcripts, which would enable you to follow along with the lecture in text format, add notes to crucial info, and skip to sections corresponding to the text. Some transcripts even have translated versions in various languages for non-English speakers.<br><br> <span class="highlight">365 Data Science</span>, on the other hand, offers downloadable pdf course notes that summarize the information from the course for those who prefer reading. Most course notes are theory-based, with a few exceptions, including the code-heavy Intro to Python and Python for Finance. You can also download code-ready templates in Python, SQL, Excel, and R, which can help accelerate your workflow.<br><br> Another advantage of having all these resources is that you can store them on your local drive and access them offline, even after canceling your subscription.',
              },
              {
                name: 'Real Environment Practice',
                text: '<strong>Coursera’s in-browsing coding function,</strong> Coursera Labs, allows students to transition from video content to coding projects seamlessly. And it connects students to environments like Jupyter Notebook.<br><br> There is, however, a significant downside to Coursera’s in-browsing coding function. Whether you need to solve a programming task as part of а job interview or have just landed a job as a data professional, more than likely, no employer will ever ask you to code in the browser.<br><br> Although <strong>convenient</strong> for the course, in-browsing coding <strong>does not apply to a real work setting.</strong> Even in a technical interview, applicants typically need to set up their working environment before beginning a task.<br><br> <span class="highlight">365 Data Science,</span> on the other hand, <strong>walks you through the entire process step by step</strong>—including how to load Python, R, Tableau, or SQL before starting a coding assignment. This gives you a <strong>tremendous competitive advantage</strong> in the data science job market.<br><br> Moreover, this approach teaches you how to solve problems in a real-world environment where coding in the browser isn’t powerful enough (e.g., with vast datasets), and you cannot ask the browser for a tip',
              },
              {
                name: 'Practical case studies',
                text: '<div>365 Data Science and Coursera put a strong emphasis on case studies.<br><br>But the difference between the two is that <strong>Coursera’s</strong> Practical Case Studies are in the form of <strong>Guided Projects</strong>—allowing students to work with hands-on tasks in a cloud desktop environment following a step-by-step approach. <br><br>Conversely, <span class="highlight">365 Data Science</span> highlights the business application of data science in its exercises and case studies. You can find the following courses in its lineup.</div><ul class="dots finish"><li>Credit Risk Modeling in Python</li><li>Customer Analytics in Python</li> <li>Time Series Analysis in Python</li> <li>Fashion Analytics with Tableau</li> <li>Product Management for AI and Data Science</li> <li>AI Applications for Business Success</li> <li>Python for Finance</li> <li>Web Scraping and API Fundamentals in Python</li></ul>',
              },
              {
                name: 'Exams',
                text: 'Exams are an excellent way to evaluate your theoretical knowledge and practical skills gained throughout the course. More importantly, passed examinations indicate a level of competence to potential employers.<br><br><span class="highlight">365 Data Science</span> provides the opportunity to test the skills you’ve acquired with three types of (timed) online exams: Practice, Course, and Career Track Exams.<br><br><strong>Practice Exams</strong> are optional. They aim to help you gain confidence in your skills, show you areas you need to work on and prepare you for your course exams and final career track exam.<br><br><strong>Course Exams</strong> test all the skills and knowledge you’ve gained at the end of each course.<br><br><strong>Career Track Exams</strong> are accessible to students who have successfully passed the nine required course exams in their chosen career track, including seven mandatory exams and two electives.<br><br><strong>Coursera</strong> offers <strong>optional Practice Quizzes</strong> that prepare you for the <strong>Module Quizzes</strong> and <strong>Module Coding Questions.</strong> You need 70% on all mandatory assessment elements to obtain a certificate, including peer-review assignments—which can cause unexpected issues. We’ll explain why in the following section.',
              },
              {
                name: 'Certificates Of Achievement vs Certificates of Completion',
                text: 'The data science industry places high value on degrees, credentials, and professional certificates—especially when an exam is required. The certificates are arguably the most significant value propositions any online learning platform can offer. Certificates not only confirm subject matter expertise but signal to employers the candidate’s willingness to work hard and achieve the goals they have set for themselves.<br><br>365 Data Science and Coursera offer <strong>industry-recognized certificates</strong> that significantly improve your chances of landing a data science job. But the way you acquire them is different.<br><br><span class="highlight">365 Data Science</span> grants <strong>two types of certificates:</strong> Course Certificates and Career Track. (We explained above how you could obtain them.) You can get a <strong>physical copy or an online certificate</strong> that you can share on LinkedIn or elsewhere.<br><br><strong>Coursera also offers data science certifications for passing a single course, course specialization, or professional program,</strong> which you can share with future employers. To obtain them, you must pass all module quizzes, hands-on projects, and peer-graded assignments with a minimum score of 70%<br><br>While Coursera’s methods to acquire such certificates are comprehensive, the <strong>peer-graded assignments</strong> require students to check each other’s work. And when introducing the deadline system to the equation, not only is it possible to get a lower grade based on an unprofessional, biased opinion, but you’re relying on others’ ability to meet deadlines. Although Coursera offers some workarounds, it’s still a <strong>hefty, lengthy process.</strong><br><br>It’s noteworthy that Coursera certificates do not display your final accumulated grade, which can be a minus for employers who want to know your exact level of skills.<br><br>(Neither 365 Data Science nor Coursera charges additional fees for online certificates.)',
              },
              {
                name: 'Q&A Support',
                text: '<span class="highlight">365 Data Science</span> provides best-in-class personalized customer support. All 365 Data Science instructors are involved in Q&A, answering specific questions—critical for beginners and a great workaround when you’re stuck and need expert tutoring.<br><br><strong>Coursera</strong> does offer Q&A support in the form of <strong>discussion forums</strong>, where students can receive <strong>peer help only.</strong> Unfortunately, Coursera students often struggle to find specialized support and solutions to their issues.',
              },
              {
                name: 'Student Ratings',
                text: 'Both platforms are well-regarded by students, but 365 has many more reviews.<br><br> As of 2022, <strong>Coursera</strong> has a 4.5/5 rating on G2’s tech marketplace based on 267 reviews and a surprising 1.7 start on Trustpilot based on 321 user opinions.<br><br> Many negative reviews come from those who have had difficulty canceling their subscriptions or had bad experiences with customer support.<br><br> With an impressive 667 reviews, <span class="highlight">365 Data Science</span> boasts 4.9/5 stars on Trustpilot. And only four students left reviews on G2, resulting in a 4.8 rating.',
              },
              {
                name: 'Pros and Cons',
                text: '<div class="title-dots-1"><strong>Coursera</strong></div><div>Pros:</div><ul class="dots"><li>Vast library</li><li>Guided Projects</li><li>Accredited courses taught by top universities and organizations</li></ul><div class="spacing">Cons:</div><ul class="dots"><li>A bit expensive</li><li>Deadline system</li><li>Peer-to-Peer Graded Assignments</li><li>No Marking System on Certificates</li></ul> <div class="highlight highlight-text">365 Data Science</div><div class="title-dots-2">Pros:</div><ul class="dots"><li>Structured Career Tracks</li><li>Real environment practice and use cases</li><li>Lessons from world-class instructors</li><li>Recognized Certificates of Achievement</li></ul><div>Cons</div><ul class="dots finish"><li>Fewer Practical Case Studies</li><li>No Guided Project</li></ul>',
              },
              {
                name: 'Pricing',
                text: '<div><strong>Coursera pricing</strong></div><ul class="dots"><li><span class="shade-light"><strong>Free subscription:</strong></span> 7-day free trial access to a specialization</li><li><span class="shade-light"><strong>Premium:</strong></span> $47–$77/month for a single specialization</li><li><span class="shade-light"><strong>Team:</strong></span> $399 billed annually for a single user</li></ul><div><strong>Coursera Plus Pricing</strong><div><ul class="dots"><li><strong>Free subscription:</strong> 7-day free trial access to a specialization</li><li><strong>Premium:</strong> $55/month for complete access to 7000+ courses</li><li><strong>Annual:</strong> $375/year; 14-day money-back guarantee</li></ul><div class="highlight highlight-text">365 Data Science Pricing</div><ul class="dots finish"><li><strong>Free subscription:</strong> access to the first 40 minutes of all courses<li><strong>Premium:</strong> $36/month or $29/month billed annually</li><li><strong>Business:</strong> starts at $696/year for two users; the first 14 days are free</li></ul>',
              },
            ],
          },
          thirdSection: {
            title: 'The Course Content: 365 Data Science vs Coursera',
            text: 'Both 365 Data Science and Coursera offer a free subscription plan. At Coursera, you will get 7-day free trial access to a specialization, while at 365 Data Science you’ll get the first section of all courses. In both cases, there is plenty to learn even from the free version!<br><br> The two business models are similar – paid subscriptions that give you access to all the content.<br><br>Currently, Coursera charges $55/month for complete access to 7000+ courses, and $375/year; 14-day money-back guarantee.<br><br>365 Data Science charges $36/month, billed monthly, or $29/month, billed annually.<br><br>',
            dataSciencePrice: '$15.37',

            planHead: {
              logo: 'LogoCoursera',
              planType: 'Plus',
              price: '$33.25',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs Coursera : Which One to Choose?',
            text: 'Ultimately, the choice between 365 Data Science and Coursera comes down to your learning needs.<br><br> <strong>Coursera</strong> has an overwhelming quantity of courses. It relies on hands-on projects and job-ready skills taught by top universities and organizations. Unless you have specific career goals, the Coursera curriculum can be overwhelming and confusing with its sheer number of courses.<br><br><span class="highlight">365 Data Science</span> is a much more beginner-friendly digital learning platform that encourages student engagement via gamified features and a vibrant community of supportive peers and instructors. It offers a self-paced and structured learning experience. While it has fewer courses than Coursera, 365’s curricula are comprehensive and well-organized. And with affordable pricing and frequent discounts, you pay next to nothing for top-notch content. The program helps you build your data science skillset from the ground up to become a sought-after professional.<br><br>If you have little to no experience in data science, 365 Data Science can help you land your dream job.',
          },
        },
        '/dataquest-alternative-365-data-science/': {
          competitorName: 'Dataquest',
          heroSection: {
            title: 'Dataquest Alternative: 365 Data Science vs Dataquest Comparison',
            subtitle: 'Course Content, Features, Pricing: Why 365 Data Science Brings More Value to Beginner Data Science Students',
            description: 'Looking to explore a <strong>Dataquest alternative</strong>? Dataquest is one of the most popular e-learning platforms for data science. Their approach is unique, as Dataquest preaches learning by doing. However, this also means that you must figure out certain things on your own. This can be frustrating and discouraging for students who want to learn data science from scratch. 365 Data Science, on the other hand, offers a program that is tailor-made for absolute beginners.<br><br>Here’s how the value proposition of our program differs from the one offered by Dataquest.',
          },
          firstSection: {
            title: 'The Course Content: 365 Data Science vs Dataquest',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum ensures you will build a solid foundation that would allow you to understand the more complicated topics included later on.',
            subtitle: '365 Data Science',
            dataScienceText: '<strong>365 Data Science</strong> offers <strong>three career tracks:</strong> Data Scientist, Data Analyst, and Business Analyst. Each one starts with Introduction to Data and Data Science–a course that provides you with an overall description of the fields of business intelligence and data science and continues with fundamental statistical concepts that develop the arithmetical thinking that every data scientist needs. <br> </br> What makes 365 Data Science particularly suitable for novice users is that each course is a natural continuation of the previous ones and takes into consideration the skill level already reached. You won’t have to go through the same explanations over and over again just because the course authors were not sure whether a given concept has been taught in previous courses.',
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: 'The <strong>Dataquest</strong> program contains many coding challenges, exercises, and case studies combined in <strong>14 skill paths and 5 career paths–</strong>Data Analyst in R, Data Analyst in Python, Data Scientist in Python, Data Engineer, and Business Analyst.<br><br>One of the biggest advantages of Dataquest is that, if you have some experience, you can go through their curriculum very quickly. Chances are you will need a fraction of the time to complete it compared to other online courses. <br> <br> There are, however, some content gaps. Spreadsheet tools are not covered in detail in Dataquest’s curriculum, except for Intro to Data Analyses with Excel. Yet, this is an essential instrument in the arsenal of anyone working with data. Data visualization with modern BI software, such as Tableau, has also been omitted.',
            competitorImage: 'dataquest-img2.jpg',
            competitorImageAlt: 'Screenshot from Dataquest’s learning platform displaying part of its course content.',
            competitorImageTitle: 'Dataquest Learning Platform',
            subText: 'Both 365 Data Science and Dataquest appear to be on the same page in terms of the logical steps to be covered. However, 365 Data Science provides video lessons and Q&A support. Dataquest puts greater emphasis on self-education through practical examples.',
          },
          secondSection: {
            title: 'Key Features: 365 Data Science vs Dataquest',
            list: [
              {
                name: 'Learning Platform',
                text: '<span class="highlight">365 Data Science</span> recognizes the challenges students face when learning data science online. To address them, it incorporated game design features, which make the whole experience fun and engaging. <br> <br> All aspects of the 365 platform are designed to support and motivate students throughout their journey. In addition to the standard dashboard where you can set goals and track your progress, it offers an XP system, leaderboard, news feed, collectible cards, and much more. <br> <br> The <strong>Dataquest</strong> platform has its advantages too. It is well-organized and very easy to navigate. From the dashboard, students can choose a learning path and track their progress.',
              },
              {
                name: 'Learning Materials',
                text: '<strong>Dataquest</strong> has a super interesting approach to learning data science. It offers coding challenges in the browser and <strong>no video</strong>. So, yes, you will have to read a great amount and pay attention. And while the hands-on experience is extremely valuable, some users, especially beginners, may find the lack of video lessons frustrating and challenging. <br> <br> In contrast, <span class="highlight">365 Data Science</span> combines comprehensive video lessons with practical examples, case studies, coding exercises, and some complementary reading materials. One of its biggest strengths are the world-class instructors from blue chip companies. <br> <br> This Dataquest alternative focuses on downloadable course materials: all exercises are in the form of coding notebook files, while the solutions are in solution notebook files. Each of them is downloadable. <br> <br>  Moreover, 365 Data Science provides plenty of additional resources, such as quizzes, course notes, and other downloadable files. Since you can store these materials locally on your computer, you get to keep all of them even after cancelling your subscription.',
              },
              {
                name: 'Real Environment Practice',
                text: 'As we mentioned, <strong>Dataquest</strong> is popular for its „coding in the browser” feature. In fact, this is one of its strongest assets, as it is very convenient. Students don’t need to switch between different windows while learning, which makes the exercise activities seamless. <br> <br>  However, there is a major downside to it. Whether you need to solve a programming task during а job interview or have just landed a job as a data professional, no employer will ever ask you to code in the browser. Instead, you will need to be confident at setting up a real environment and solving complex tasks in it. <br> <br> And that is exactly what <span class="highlight">365 Data Science</span> provides in each programming-related course–not only are there lessons dedicated to setup, but all exercise and practical tasks are carried out within the actual environment. This prepares you for the real-world challenges of any data science or analytics job. <br> <br>  What’s more, this approach will teach you how to solve problems in a real-world environment where coding in the browser isn’t powerful enough (for example, with very large datasets) and where you can’t ask the browser for a tip.',
              },
              {
                name: 'Practical Case Studies',
                text: 'Dataquest and 365 Data Science both focus extensively on practical examples. <br> <br>  The main difference is that many of the challenges and tasks by <strong>Dataquest</strong> are not centered around business applications. The program does not include industry-specific use cases, except for APIs and Web Scraping in Python. <br> <br>  On the other hand, <span class="highlight">365 Data Science</span> highlights the business application of data science in its exercises and case studies. In its line-up, you can find courses like: <br> <ul class="dots"><li>Credit Risk Modeling in Python</li><li>Customer Analytics in Python</li><li>Time Series Analysis in Python</li><li>Fashion Analytics with Tableau</li><li>Product Management for AI and Data Science</li><li>AI Applications for Business Success</li><li>Python for Finance</li><li>Web Scraping and API Fundamentals in Python</li></ul>',
              },
              {
                name: 'Exams',
                text: 'Exams indicate you meet a high standard of competence and can give you a competitive advantage, leading to more job opportunities and a higher pay scale. <br> <br>  <span class="highlight">365 Data Science</span> provides the opportunity to test the skills you have acquired with 3 types of timed online exams–Practice Exams, Course Exams, and Career Track Exams. <br> <br>  <strong>Practice Exams</strong> are optional. Their goal is to help you gain confidence in your skills, show you if there are areas you still need to work on, and prepare you for your course exams and final career track exam. <br> <br> <strong>Course Exams</strong> give you the chance to prove that you have gained the necessary skills and competencies in a certain data science area. <br> <br> <strong>Career Track Exams</strong> are accessible to students who have successfully passed the required course exams in their chosen career track. <br> <br> Presently, <strong>Dataquest</strong> doesn’t offer exams as a feature of their training.',
              },
              {
                name: 'Certificates: Dataquest vs 365 Data Science',
                text: '<span class="highlight">365 Data Science</span> offers 2 types of Certificates of Achievement–Course Certificates and Career Track Certificates. Both are official 365 Data Science credentials that confirm your accomplishment and domain expertise. <br> <br> It is not necessary to watch all the videos in a course to earn a <strong>Course Certificate</strong>. However, you do need to be enrolled in the program and pass the course exam successfully with a score of 60% or higher. <br> <br> To earn a <strong>Career Track Certificates</strong>, you need to pass 10 exams successfully–9 course exams plus a final exam with questions covering all required courses in the respective Career Track. Again, you need a score of 60% or higher. <br> <br> Once earned, you can easily share them with your professional LinkedIn network or get a physical copy as a stylish testament to your achievement. <br> <br> <strong>Dataquest</strong> offers <strong>Certificates of Completion</strong>, which are granted upon completing any course on the platform without the need to take an exam. If you’re counting on the Dataquest certificate to prove your experience, you may be disappointed. <br> <br> The data science industry places high value on degrees, credentials, and professional certificates, especially when there is an exam required to obtain them. There is a good reason for that–certificates not only confirm subject matter expertise but are also required for certain job openings. Not to mention that employers consider certificates a measure of a candidate’s willingness to work hard and achieve the goals they have set for themselves. <br> <br> Recently, <strong>Dataquest</strong> introduced a Capstone Project–an unsupervised piece of work that students must complete successfully to earn a certificate in the Business Analyst with Python career path. <br> <br> Neither 365 Data Science nor Dataquest charge an additional fee for the online certificates.',
              },
              {
                name: 'Q&A Support',
                text: '<span class="highlight">365 Data Science</span> offers best-in-class personalized customer support. All 365 Data Science instructors are involved in Q&A, answering any specific questions students might have. This is critical for beginners and is a great workaround when you get stuck and need some expert tutoring. <br> <br> <strong>Dataquest</strong> does a great job in helping students, too, with its well-maintained and moderated community forum. You can post a question if you get stuck while doing one of the course challenges. <br> That said, the only 1-star review on Dataquest we found online was regarding the poor customer support. The dissatisfied customer complained about the way the team handled their refund request. Still, this is rather an isolated occurrence, as the majority of Dataquest reviews online are positive.',
              },
              {
                name: 'Student Ratings',
                text: 'Both platforms are well-regarded by students, but 365 has many more reviews. <br> <br> As of 2022, <strong>Dataquest</strong> has a 4.8 rating on G2 based on 44 reviews and 4.3 start on Trustpilot based on 11 user opinions. <br> <br> With the impressive 667 reviews, <span class="highlight">365 Data Science</span> boasts 4.9 stars on Trustpilot. Only 4 students have left reviews about it on G2, resulting in a 4.8 rating.',
              },
              {
                name: 'Pros and Cons',
                text: '<div class="title-dots-1"><strong>Dataquest</strong></div><div>Pros:</div><ul class="dots"><li>Well-structured curriculum</li><li>Takes less time to complete a course</li><li>Emphasis on practical experience</li></ul><div class="spacing">Cons:</div><ul class="dots"><li>Some content gaps</li><li>No video lessons</li><li>Lacking industry-specific use cases</li></ul> <div class="highlight" class="highlight-text">365 Data Science</div><div class="title-dots-2">Pros:</div><ul class="dots"><li>Real environment practice and use cases</li><li>Lessons from world-class instructors</li><li>Recognized Certificates of Achievement</li></ul><div>Cons:</div><ul class="dots"><li>Fewer Career Tracks than Dataquest</li><li>Courses take longer to complete</li></ul>',
              },
              {
                name: 'Pricing',
                text: '365 Data Science and Dataquest have similar pricing structures–a free plan with plenty of content available, a premium subscription with access to the entire platform, and a business package. <br> <br> <strong>Dataquest Pricing</strong><ul class="dots"><li><strong>Free subscription:</strong> access to all introductory lessons</li><li><strong>Premium:</strong> $49/month or $33.25/month billed annually</li><li><strong>Team:</strong> $1,176 billed once</li></ul> <div class="highlight" class="highlight-text">365 Data Science Pricing</div><ul class="dots"><li><strong>Free subscription:</strong> access to the first few lessons of all courses</li><li><strong>Premium:</strong> $36/month or $29/month billed annually</li><li><strong>Business:</strong> starts at $696/year for 2 users; the first 14 days are free</li></ul>',
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs Dataquest',
            text: 'Both 365 Data Science and Coursera offer a free subscription plan. At Coursera, you will get 7-day free trial access to a specialization, while at 365 Data Science you’ll get the first section of all courses. In both cases, there is plenty to learn even from the free version!<br><br> The two business models are similar – paid subscriptions that give you access to all the content.<br><br>Currently, Coursera charges $55/month for complete access to 7000+ courses, and $375/year; 14-day money-back guarantee.<br><br>365 Data Science charges $36/month, billed monthly, or $29/month, billed annually.<br><br>',
            dataSciencePrice: '$15.37',
            planHead: {
              logo: 'LogoDataQuest',
              planType: 'Premium',
              price: '$33.25',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: false,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs Dataquest: Which One to Choose?',
            text: 'Both e-learning platforms offer a rich portfolio of courses and practical exercises. The main difference is the “video” vs. “non-video” approach. In addition, 365 Data Science and Dataquest provide verifiable certificates to their students. But which one is the best for your learning needs and is Dataquest worth it? <br> <br> Let’s find out. <br> <br> <strong>Dataquest</strong> is a great resource for anyone who has some experience with programming, data analysis, or data science in general. The structure of the curriculum is extremely efficient. You can solve many interesting exercises on your own and save time. <br> <br> In contrast, <span class="highlight">365 Data Science</span> focuses on the beginner data scientist and offers a fully integrated all-in-one learning solution. The training is designed to ensure the student has mastered the fundamentals before building up with more advanced concepts. <br> <br> 365 Data Science will teach you the necessary linear algebra and statistics skills to later model your data and the three key programming languages (Python, SQL, and R) to help you start developing machine learning algorithms. The platform also focuses heavily on student-teacher feedback, where the beginner learner is fully supported. <br> <br> In essence, if you are a beginner, the 365 Data Science curriculum structure provides a superior learning experience and a more supportive environment.',
          },
        },
        '/datacamp-alternative-365-data-science/': {
          competitorName: 'DataCamp',
          heroSection: {
            title: 'DataCamp Alternative: 365 Data Science vs DataCamp Comparison',
            subtitle: 'Course Content, Features, Pricing: Why 365 Data Science Brings More Value to Beginner Data Science Students ',
            description: 'DataCamp is one of the most popular platforms for e-learning. But students have diverse learning goals and needs regarding online data science training. If you are looking for a DataCamp alternative, 365 Data Science is a comprehensive platform that you can rely on to advance your skills, prepare for every aspect of the job application process, and start your career. <br><br>The following addresses how the value proposition of 365’s program differs from that of DataCamp.',
          },
          firstSection: {
            title: 'The Course Content: 365 Data Science vs DataCamp',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later.',
            subtitle: '365 Data Science',
            dataScienceText: '<strong>365 Data Science</strong> offers <strong>three career tracks:</strong> Data Scientist, Data Analyst, and Business Analyst. Each track starts with an Introduction to Data and Data Science—a course that comprehensively describes Business Intelligence (BI) and Data Science. All the Career Tracks teach fundamental and essential statistical concepts required for data analysis and further expand on those skills with advanced probability concepts necessary for you to think like a data scientist. <br> <br> What makes 365 Data Science particularly suitable for novice users is that each course is a natural continuation of the previous ones and considers skill levels already reached. You won’t need to repeat the same explanations because the course authors were unsure whether a given concept had been taught in previous courses. The program features world-class instructors who have gained working experience with such firms as (among others) Meta, Google, Spotify, Ikea, and Henkel.',
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: '<strong>DataCamp</strong> offers an impressive 392 courses from more than 276 instructors, 15 Career Tracks, and 50 Skill Tracks. These courses are part of the more extensive portfolio available to all subscribers but have not been included in the ‘Data Scientist with R’ track, which, surprisingly, doesn’t incorporate linear algebra or probability, which are foundational data science topics. <br> <br> Many DataCamp courses provide an excellent learning opportunity, but they’re also challenging to navigate—especially in the beginning when a student may not understand the logical order. Still, if you’re an experienced data scientist working on a particular problem, chances are DataCamp would be able to help you with your project. <br> <br> Another essential difference between the two programs is that 365 Data Science focuses extensively on using Tableau, Python, R, and Excel as visualization tools. In contrast, DataCamp doesn’t cover data visualization in Excel. ',
            competitorImage: 'data-camp-img2.jpg',
            competitorImageAlt: 'Screenshot from DataCamp’s learning platform displaying part of its course content.',
            competitorImageTitle: 'DataCamp Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
          },
          secondSection: {
            title: 'Key Features of 365 Data Science & DataCamp',
            list: [
              {
                name: 'Learning Platform',
                text: 'One of the biggest challenges of online learning platforms is creating engagement among students, which helps them make the most of their learning experience. <br> <br> <span class="highlight">365 Data Science</span> designed a platform with gamified features to support and motivate students to build positive learning habits, which are rewarded with various benefits. In addition to the standard dashboard—where you set goals and track your progress—365 also offers an XP system, leaderboard, news feed, collectible cards, and much more. <br> <br> <strong>DataCamp</strong>, on the other hand, does not offer gamified features apart from an XP system that measures your engagement with the platform based on the exercises, courses, and tracks you have completed. Students do not get rewards for earning XPs nor have a leaderboard where they can compete with other motivated learners—making the experience less memorable.',
              },
              {
                name: 'Learning Material',
                text: '365 Data Science and DataCamp provide access to exercises that help students practice what they’ve learned. <br> <br> <strong>DataCamp’s</strong> native ‘coding in the browser’ feature is believed to be one of its strongest assets. Students don’t need to switch between different windows while learning, which makes exercise activities seamless. Unfortunately, DataCamp’s resources are not downloadable and require internet access. <br> <br> Alternatively, <span class="highlight">365 Data Science</span> focuses on course materials. All exercises are in the form of coding and solution notebook files. Moreover, 365 provides many additional resources, such as quizzes, course notes, templates, and other downloadable files, which you can keep even after canceling your subscription.',
              },
              {
                name: 'Real Environment Practice',
                text: 'As previously noted, <strong>DataCamp</strong> is renowned for its coding in the browser feature. There is, however, a significant downside to this. Whether you need to solve a programming task during a job interview or have landed a job as a data professional, no employer will ever ask you to code in the browser. If this were the case, you’d need to be highly confident in setting up the real environment and solving complex tasks in the browser. <br> <br> <span class="highlight">365 Data Science</span> provides lessons dedicated to the set up in each programming-related course. All exercises and practical tasks are performed in a real environment to prepare you for the real-world challenges of any data science or analytics job and datasets of any size.',
              },
              {
                name: 'Practical Case Studies',
                text: '<span class="highlight">365 Data Science</span> provides practical case studies where students can practice what they’ve learned in a practical context and highlights the business application of data science in their exercises. For example, 365 Data Science’s Probability Course features real-world data from Hamilton College, requiring students to apply the Bayesian Law to determine whether the college successfully diversifies its student population. <br> <br> <strong>DataCamp</strong> offers a more significant number of advanced practical case studies in its course curriculum. If you’re a data scientist facing a particular problem, there is a good chance you’ll make a breakthrough with your project via DataCamp’s resources.',
              },
              {
                name: 'Exams',
                text: 'Exams indicate you meet a high standard of competence. They can give you a competitive advantage, more job opportunities, and a higher pay scale. <br> <br> <span class="highlight">365 Data Science</span> allows you to test the skills you’ve acquired with three types of timed online exams: Practice Exams, Course Exams, and Career Track Exams. <br> <br> <strong>Practice Exams</strong> are optional. They aim to help you gain confidence in your skills, present areas you need to work on, and prepare you for your course and final career track exams. <br> <br> <strong>Course Exams</strong> allow you to prove that you’ve gained the necessary skills and competencies in a specific data science area. A passing score of 60% is required to be eligible for a Course Certificate. <br> <br> <strong>Career Track Exams</strong> are accessible to students who have successfully passed the required course exams in their chosen career track (Data Scientist, Data Analyst, or Business Analyst). The Career Tracks include eight mandatory courses and two electives. A passing score of 60% is required to be awarded a Career Track Certificate. <br> <br> <strong>DataCamp,</strong> on the other hand, does not offer exams on its courses, career tracks, or skill tracks. They provide skill assessments that evaluate a student’s skill level on a given topic/skill and deliver personalized learning recommendations based on the results. <br> <br> But DataCamp has recently introduced Timed Exams and Practical Exams as part of their Data Analyst and Data Scientist Certification. The Practical Exam is a case study that revolves around a real-world problem you must solve using the data set given to you. After completing your analyses, you must share your results in a presentation.',
              },
              {
                name: 'Certificates',
                text: 'Perhaps, one of the most significant value propositions an online platform can offer to its students—besides quality content—are industry-recognized certificates that signal to employers that candidates have the necessary technical skills and character traits for the job. <br> <br> Consequently, <span class="highlight">365 Data Science</span> replaced their Certificates of Completion—which required students to view the entire course content—with Certificates of Achievements, which entails students successfully passing their course exam with a minimum grade of 60%. <br> <br> Career Track Certificates are granted to students who have successfully passed all their course exams in the track and career track exam. <br> <br> This rigorous approach to earning a certificate provides job-market value and prepares students for real-life problems they’re expected to solve. <br> <br> <strong>DataCamp,</strong> on the other hand, offers only certificates of completion for their courses. The only requirement to receive them is to go through all the lessons and exercises—giving the certificates less job-market value. <br> <br> But Data Camp has recently addressed this issue by releasing its DataCamp Certifications, which require students to go through timed examinations and projects to earn a certificate. Once students register for one of four certifications (Data Science Associate, Data Analytics Associate, Data Science Professional, and Data Analytics Professional), they have only 30 days to complete all requirements. <br> <br> This deadline can be helpful to some who need that extra push but could cause problems for students who live busy lives and juggle between work, studies, and personal life.',
              },
              {
                name: 'Q&A support',
                text: '<span class="highlight">365 Data Science</span> offers best-in-class personalized customer support, addressing students’ specific questions. This is critical for beginners and an excellent workaround for students needing expert tutoring. All 365 Data Science instructors are involved in Q&A support, ensuring the most coherent experience possible for each student. <br> <br> <strong>DataCamp</strong> does not offer Q&A support services, and students cannot contact instructors—at least not through the platform. But it does provide access to the DataCamp Slack community, where you’re more likely to get peer help than instructor support.',
              },
              {
                name: 'Student Ratings',
                text: 'Both DataCamp and 365 Data Science have positive reviews on G2. But DataCamp has more reviews, with a 4.6/5 rating from 125 reviews, while 365 Data Science boasts 4.8/5 from four reviews. <br> <br> On Trustpilot, <strong>DataCamp</strong> reviews are 234 and scores 4.6/5, with many positive reviews about its outstanding customer support. <br> <br> <span class="highlight">365 Data Science</span> features an impressive 4.9/5 from 669 reviews, with positive reviews on its course structure and beginner friendliness.',
              },
              {
                name: 'Pros and Cons',
                text: '<div class="title-dots-1"><strong>DataCamp</strong></div><div>Pros:</div><ul class="dots"><li>Extensive library of courses on different topics</li><li>More extensive library of projects and case studies</li></ul><div class="spacing">Cons:</div><ul class="dots"><li>Lack of graded exams</li><li>Some outdated courses</li><li>No instructor feedback/help</li><li>No downloadable resources</li></ul> <div class="highlight" class="highlight-text">365 Data Science</div><div class="title-dots-2">Pros:</div><ul class="dots"><li>Industry-recognized certificates</li><li>Beginner-friendly</li><li>Comprehensive career tracks</li><li>Plenty of learning resources</li><li>Gamified platform</li></ul><div>Cons:</div><ul class="dots"><li>Fewer practical case studies</li><li>Fewer projects</li></ul>',
              },
              {
                name: 'Pricing: 365 Data Science vs DataCamp',
                text: '<div class="title-dots-1"><strong>DataCamp Pricing</strong></div><ul class="dots"><li><strong>Free subscription:</strong> Each first chapter is free</li><li><strong>Premium:</strong> $12/month billed annually or $15/month</li></ul> <div class="highlight" class="title-dots-1">365 Data Science Pricing</div><ul class="dots"><li><strong>Free subscription:</strong> Access to the first lessons of every course</li><li><strong>Premium:</strong> $36/month or $29/month billed annually</li></ul>',
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs DataCamp',
            text: 'Both 365 Data Science and Coursera offer a free subscription plan. At Coursera, you will get 7-day free trial access to a specialization, while at 365 Data Science you’ll get the first section of all courses. In both cases, there is plenty to learn even from the free version!<br><br> The two business models are similar – paid subscriptions that give you access to all the content.<br><br>Currently, Coursera charges $55/month for complete access to 7000+ courses, and $375/year; 14-day money-back guarantee.<br><br>365 Data Science charges $36/month, billed monthly, or $29/month, billed annually.<br><br>',
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoDataCamp',
              planType: 'Premium',
              price: '$12',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs DataCamp: Which one to choose?',
            text: 'By now you are probably wondering if DataCamp is worth it? Choosing between the two platforms ultimately depends on your preferences and learning needs.<br><br>If you get a <strong>DataCamp</strong> subscription, you will access a broader selection of courses, projects, and case studies which can benefit students who already have experience in the field. <br> <br> <span class="highlight">365 Data Science</span>’s structured learning curriculum, supportive community, and gamified platforms provide a superior learning experience for beginners who wish to build their skills from the ground up, stay engaged throughout the process, and become job-ready professionals. All this makes 365 Data Science a great alternative to DataCamp.<br><br>So, if you’re new to the world of data and need help knowing where to start, then 365 Data Science is the right platform for you.',
          },
        },
        '/codecademy-alternative-365-data-science/': {
          competitorName: 'Codecademy',
          heroSection: {
            title: 'Codecademy Alternative: 365 Data Science vs Codecademy Comparison',
            subtitle: 'Course Content, Features, Pricing: Why 365 Data Science Brings More Value to Beginner Data Science Students',
            description: 'Codecademy, founded in 2011, is an online data science learning platform that initially offered free courses but later introduced paid plans to students. While Codecademy’s text-based courses and diverse curriculum of programming languages may be helpful to some students, 365 Data Science’s video-based and overall learning approach might better meet students’ needs. If you are looking for alternatives to Codecademy, you’ve come to the right place.<br><br>In the next sections, we are going to look at the comparison between Codecademy and 365 Data Science, and which platform offers the superior learning experience.',
          },
          firstSection: {
            title: 'Course Content: 365 Data Science vs Codecademy',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later, including programming languages like SQL, R, Python, and Excel and valuable business concepts.<br><br>',
            subtitle: '365 Data Science',
            dataScienceText: 'The curriculum of <strong>365 Data Science</strong> offers three career tracks: Data Scientist, Data Analyst, and Business Analyst. Each track starts with an Introduction to Data and Data Science. Each course comprehensively covers fundamental concepts and provides guided assignments and practice exams that help students strengthen their knowledge.<br><br>What makes 365 Data Science particularly suitable for novice users is that each course is a natural continuation of the previous ones and considers skill levels already reached. You won’t need to adhere, for example, to repeated explanations just because the course authors were unsure whether a given concept had been taught in previous courses.',
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: 'As the name suggests, <strong>Codecademy’s</strong> curriculum focuses more on coding—covering the previously mentioned languages plus (among others) HTML, JavaScript, PHP, and C++. They also offer nine Career Paths, including Full Stack Engineer, Front End Engineer, Back End Engineer, Computer Science, IOS Developer, and a Data Scientist Career Path. Those paths provide the following four specializations: Machine Learning, Data Analytics, Natural Language Processing, and Interference. Like 365 Data Science’s approach, each data Career Path begins with the Foundations of Data Science, where students can learn the general data science skills needed to specialize in their field of choice. Codecademy’s students can enroll in Skill Paths to help them master a particular skill like web development, machine learning, mobile development, and much more. Moreover, Codecademy offers 12 Career Paths, 46 Skill Paths, and 120+ individual courses. While Codecademy provides more diverse educational content, 365 Data Science differs in a few ways.',
            competitorImage: 'codecademy.jpg',
            competitorImageAlt: 'Screenshot from Codecademy’s learning platform displaying part of its course content.',
            competitorImageTitle: 'Codecademy Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: 'The <strong>365 Data Science</strong> curriculum is taught by industry experts from diverse academic and industrial backgrounds to ensure a high-quality teaching standard. Codecademy does not feature the names of its instructors, making it more difficult for students to conduct background checks or research. <br> <br> The 365 video-based format teaching strongly emphasizes theory, taught in a systematic and step-by-step fashion, which Codecademy’s text-based teaching focuses less on theory and more on guided exercises that you must complete to advance to the next section of the course.',
          },
          secondSection: {
            title: 'Key Features',
            list: [
              {
                name: 'Learning Platform',
                text: '<span class="highlight">365 Data Science</span> acknowledges the challenges students face with online learning, such as the lack of engagement, accountability, motivation, and enjoyment. Their platform offers gamified features that encourage positive learning habits to address these issues. In addition to the standard learning dashboard where you set goals and track your progress, the platform provides an EXP system, newsfeed, collectible cards, and other benefits. <br> <br> <strong>Codecademy</strong> also offers the standard learning dashboard but none of the above-gamified features. They do have a convenient focus timer feature that allows you to pace your learning. Another useful feature they have includes the saved resources buttons that enable you to save docs, cheat sheets, and articles in one place for later use.',
              },
              {
                name: 'Learning Material',
                text: 'While 365 Data Science and Codecademy seem to be on the same page regarding providing students with the same learning materials, there are a few key differences. <br> <br> <span class="highlight">365 Data Science’s</span> resources are downloadable to your drive, which can be accessed offline even after canceling your subscription. <br> <br> The only way to access your saved <strong>Codecademy</strong> resources is by logging in to your profile. <br> <br> 365 Data Science offers course notes that are detailed text-based pdf files covering the concepts and formulas in each course. At the same time, the Codecademy equivalent is cheat sheets, which are concise summaries of the concepts from a course section. <br> <br> Both e-learning platforms offer code-ready templates. The main difference here is the working environment in which they can be used. 365 Data Science templates need the respective programs to be used, while Codecademy has in-browser coding. In the next section, we’ll go over the environment in greater detail on why in-browser coding might disadvantage many students.',
              },
              {
                name: 'Real Environment Practice',
                text: '<strong>Codecademy’s</strong> in-browsing coding function allows students to code inside the platform, saving set-up time and making it more convenient to follow text-based instructions and tips. <br> <br> The big downside, however, is that in real-life situations and interviews, you must be confident enough to set up your own environment for coding and solve real-world tasks in the respective domains. Plus, no one will give you tips whenever you get stuck in your coding schemes. <br> <br> <span class="highlight">365 Data Science</span>, on the other hand, walks you through the entire process step by step—including how to load Python, R, Tableau, or SQL before starting a coding assignment. This gives you a tremendous competitive advantage in the data science job market. Moreover, this approach teaches you how to solve problems in a real-world environment where coding in the browser isn’t powerful enough for massive datasets.',
              },
              {
                name: 'Practical Case Studies',
                text: '365 Data Science and Codecademy emphasize practical case studies that allow students to practice what they’ve learned from the lessons in a practical context. <br> <br> The difference here is that <strong>Codecademy’s</strong> case studies come from practice and portfolio projects. They focus on topics such as machine learning in Python which you can add to your portfolio. The Practice Projects provide tips and video walkthroughs for those who feel stuck. At the same time, Portfolio Projects provide high-level tasks where you’re expected to use Codecademy and other internet resources to complete your project. The emphasis is on finding your own approach and solutions. <br> <br> It’s important to note that the Portfolio Projects require you to set up real-world environments. If you have difficulties installing it, you can turn to Codecademy’s articles and videos. <br> <br> Conversely, <span class="highlight">365 Data Science</span> highlights the business application of data science in its exercises and case studies in courses such as Python for Finance <ul class="dots"><li>Credit Risk Modeling in Python</li><li>Time Series Analysis in Python</li><li>Ai Applications for Business Success</li><ul>',
              },
              {
                name: 'Exams',
                text: 'Exams are an excellent way to evaluate your theoretical knowledge and practical skills gained throughout the course. More importantly, passed examinations indicate your level of expertise and competence to future employers.<br><br><span class="highlight">365 Data Science</span> takes the lead in terms of quality and quantity. The platform provides the opportunity to test the skills you’ve acquired with three types of (timed) online exams: Practice Exams, Course Exams, and Career Track Exams. <br> <br> <strong>Practice Exams</strong> are optional. They aim to help you gain confidence in your skills, show you areas you need to work on and prepare you for your course exams and final career track exam. <br> <br> <strong>Course Exams</strong> test all the practical skills and theoretical knowledge you’ve gained at the end of each course. <br> <br> <strong>Career Track Exams</strong> are accessible to students who have successfully passed the required course exams in their chosen career track, including seven mandatory exams and two electives. <br> <br> <strong>Codecademy</strong>, on the other hand, does not offer comprehensive exams, only short practice quizzes that test your knowledge of a specific course section.',
              },
              {
                name: 'Certificates',
                text: 'Arguably, the main selling proposition of any online learning platform includes the certificates it issues to students upon successful completion of a course or career track. The data science industry places high value on certificates because they indicate that the student has the necessary technical skills and character traits to be a good job candidate. <br> <br> <span class="highlight">365 Data Science</span> provides industry-recognized certificates that significantly increase students’ chances of landing a data science job. Students can earn two types of certificates (Course Certificates and Career Track Certificates) which are granted upon the successful completion of exams with a score of at least 60%. <br> <br> <strong>Codecademy</strong> offers certificates of completion that are easier to acquire since they don’t have assessment-based certification—all you need to do is complete all the practice quizzes and exercises. This also means that Codecademy certificate value is lower in the job market. <br> <br> Neither 365 Data Science nor Codecademy charges additional fees for online certificates.',
              },
              {
                name: 'Q&A support',
                text: '<span class="highlight">365 Data Science</span> provides superb, personalized customer support, where instructors are actively engaged in answering specific questions from the platform’s Q&A section. Such support is vital for beginners and when they need help or expert tutoring. <br> <br> <strong>Codecademy</strong> offers community forums and a discord group where students can turn for peer help when experiencing difficulties with a particular problem from the course. Unfortunately, students cannot receive professional support from instructors, and the forum’s navigation is not the most user-friendly.',
              },
              {
                name: 'Student Ratings',
                text: '<strong>365 Data Science and Codecademy</strong> platforms are well-regarded by students, although Codecademy reviews are more on G2 and Trustpilot review platforms. <br> <br> As of 2022, <strong>Codecademy</strong> has a 4.4/5 rating on G2’s tech marketplace based on 147 reviews and a 4.2 rating on Trustpilot from 1,331 user opinions. <br> <br> With an impressive 667 reviews, <span class="highlight">365 Data Science</span> boasts 4.9/5 stars on Trustpilot. And only four students left reviews on G2, resulting in a 4.8 rating.',
              },
              {
                name: 'Pros and Cons',
                text: '<div class="title-dots-1"><strong>Codecademy</strong></div><div>Pros:</div><ul class="dots"><li>Diverse Portfolio Projects</li><li>Plethora of external informational resources</li><li>Diverse curriculum of software development and programming languages</li></ul><div class="spacing">Cons:</div><ul class="dots"><li>No exams</li><li>Fewer video lessons</li><li>Lack of graded assignments</li></ul> <div class="highlight" class="highlight-text">365 Data Science</div><div class="title-dots-2">Pros:</div><ul class="dots"><li>Real environment practice and use cases</li><li>Lessons from world-class instructors</li><li>Recognized Certificates of Achievement</li></ul><div>Cons:</div><ul class="dots"><li>Fewer Practical Case Studies</li><li>No Guided Projects</li></ul>',
              },
              {
                name: 'Pricing',
                text: 'Codecademy and 365 Data Science offer free content to students who want to taste the platforms’ teaching styles before deciding on a plan. 365 Data Science allows students access to the first chapters of each course and the resources and practice exams in them. In this way, students have an excellent opportunity to decide if they want to upgrade. <br> <br> Codecademy’s free plan allows students to access the free courses, but you need a Pro membership to access all the practice quizzes, portfolio projects, and walkthrough videos.  <br> <br> <div class="title-dots-1"><strong>Codecademy Pricing</strong></div><ul class="dots"><li><strong>Basic subscription:</strong> free</li><li><strong>Pro Lite:</strong> $13.99/month billed annually</li><li><strong>Pro:</strong> $19.99/month billed annually</li></ul> <div class="highlight" class="title-dots-1">365 Data Science Pricing</div><ul class="dots"><li><strong>Free subscription:</strong> access to the first few lessons of all courses</li><li><strong>Premium:</strong> $36/month or $29/month billed annually</li></ul>',
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs Codecademy',
            text: '365 Data Science is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later, including programming languages like SQL, R, Python, and Excel and valuable business concepts.<br><br>',
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoCodeAcademy',
              planType: 'Pro',
              price: '$19.99',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: false,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs Codecademy: Which One to Choose?',
            text: 'By now you are probably asking yourself if Codecademy is worth it?<br><br><strong>Codecademy</strong> is an excellent choice if you’re interested in learning various programming/coding languages, thanks to its extensive library of courses. It also offers a wider variety of practical data science projects which you can add to your portfolio. The fewer video lessons, text-based instructions, and links to external resources for information and tips give Codecademy a more self-study approach that might appeal to some students. <br> <br> <span class="highlight">365 Data Science</span> is a great alternative for Codecademy. The platform compensates for the lack of (comparatively speaking) courses and projects with its comprehensive video lessons taught by industry experts and industry-recognized certificates.<br><br>If you’re looking for a systematic curriculum and an engaging platform that motivates you to study and become job-ready, then 365 Data Science is the right choice.',
          },
        },
        '/linkedin-learning-alternative-365-data-science/': {
          competitorName: 'LinkedIn Learning',
          heroSection: {
            title: 'LinkedIn Learning Alternative: 365 Data Science vs LinkedIn Learning Comparison',
            subtitle: 'Course Content, Features, Pricing: Why 365 Data Science Brings More Value to Beginner Data Science Students',
            description: 'LinkedIn Learning, formerly Lynda, is a popular learning library that offers over 20,000+ video courses, taught by real-world professionals, on business, finance, digital design, programming, and data science topics. But is there an alternative to LinkedIn Learning for Data Science courses? While 365 Data Science shares similarities with LinkedIn Learning regarding the standard of instructors and video-format teaching style, 365’s overall learning approach differs in a few key ways that might meet students’ needs better.',
          },
          firstSection: {
            title: 'Course Content: 365 Data Science vs LinkedIn Learning',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later.<br><br>',
            subtitle: '365 Data Science',
            dataScienceText: '<strong>365 Data Science</strong> offers three career tracks: Data Scientist, Data Analyst, and Business Analyst. Each track starts with an Introduction to Data and Data Science that sets the groundwork for the upcoming concepts and theory.<br><br>What makes 365 Data Science particularly suitable for novice users is that each course is a natural continuation of the previous ones and considers skill levels that are already reached. You won’t need to adhere, for example, to repeated explanations just because the course authors were unsure whether a given concept had been taught in previous courses. All the Career Tracks teach fundamental statistical concepts required for working with data. Additionally, the Data Science career track dives into great detail on advanced probability concepts necessary for students to become competent data scientists who can think computationally.',
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: 'Regarding the amount of content, <b>LinkedIn Learning</b> courses are over 500 on data science topics, which gives them the edge. But, on closer inspection, we can see overlap in the material in courses like Introduction to Data Science, Data Science and Analytics Career Paths and Certifications: First Steps, and Data Science Foundation Fundamentals. In addition, the considerable number of courses on any single topic can overwhelm the beginner data scientist student, who may not know which course to choose. <br> <br> Like 365’s Career Tracks, LinkedIn Learning Paths offer structured way of learning the necessary skills to become a data science professional. But LinkedIn’s Data Scientist Learning path goes into less detail on some of the essential statistical concepts required for data science and omits important concepts like hypothesis testing and confidence intervals—all of which are covered in the 365 Data Scientist Career Tracks.',
            competitorImage: 'linkedIn-learning.jpg',
            competitorImageAlt: 'Screenshot from LinkedIn Learning’s learning platform displaying part of its course content.',
            competitorImageTitle: 'LinkedIn Learning Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: 'LinkedIn’s Data Scientist Learning Path also focuses more on the theoretical side of machine learning matters and programming in Python. It encourages students to find detailed practical courses on these topics outside of the path—which defeats the purpose of the learning path in the first place. <br> <br> In contrast, the 365 Data Science Career Path consists of such comprehensive courses as Machine Learning in Python and Python Programmer Bootcamp—which lean heavily on guided hands-on exercises that gradually build students’ skill levels.',
          },
          secondSection: {
            title: 'Key Features',
            list: [
              {
                name: 'Learning Platform',
                text: 'Learning platforms play an essential role in the learning experience and can often decide if students study only occasionally or every day. <br> <br> The <span class="highlight">365 Data Science</span> platform introduced the following gamified features to increase student engagement, encouraging students to build positive learning habits. <ul class="dots"><li>XP Mechanic: Each time you finish a video or complete an exam or quiz, you gain experience points (XPs) that help you level up and climb the rank ladders.</li><li>Leaderboard: This is where the most ambitious learners compete for the top ranks and get rewarded for climbing divisions with coins and XPs.</li><li>365 Card Collections: These are hand-drawn cards of the founding figures of mathematical sciences that grant unique in-game and real-life benefits whenever you unlock them.</li></ul><strong>LinkedIn Learning</strong>, on the other hand, does not offer gamified features. They provide standard platform features that allow you to track your course progress and set weekly goals. And, like Coursera, they have interactive transcripts that enable you to follow along and navigate through videos.',
              },
              {
                name: 'Learning Material',
                text: 'Learning materials help students assimilate the subject matter quicker and in ways that course videos cannot. 365 Data Science and LinkedIn Learning offer downloadable resources that can be stored on your computer and accessed offline. <br> <br> Besides offering exercise files with videos, <span class="highlight">365 Data Science</span> provides plenty of different resources that meet students’ needs, including the following: <br> <br> <strong>Course Notes:</strong> free pdf text files that present essential concepts from a given course. <br> <br> <strong>Templates:</strong> code-ready templates that accelerate your workflow and save you time from browsing on the internet. <br> <br> <strong>Infographics:</strong> pdf files with colorful and impressive visuals that help beginners present the bigger picture of the complex world of data science. <br> <br> <strong>LinkedIn Learning,</strong> on the other hand, provides only exercise files that might not meet specific students’ learning needs.',
              },
              {
                name: 'Real Environment Practice',
                text: 'Both <strong>LinkedIn Learning</strong> and <span class="highlight">365 Data Science</span> offer coding in real environments and video instructions on how to set it up. <br> <br> Although less convenient than in-browser coding—which allows students to transition from video to coding seamlessly—the pros of practicing your skills in a real environment far outweigh the disadvantages. All employers expect you to set up your own program and solve real-world problems.<br><br> Moreover, this approach teaches you how to solve problems in a real-world environment where coding in the browser isn’t powerful enough for massive datasets.',
              },
              {
                name: 'Practical Case Studies',
                text: '<span class="highlight">365 Data Science</span> provides practical case studies where students can practice what they’ve learned in a practical context and highlights the business application of data science in their exercises and case studies. For example, 365 Data Science’s Probability Course features real-world data from Hamilton College, requiring students to apply the Bayesian Law to determine whether the college successfully diversifies its student population. <br> <br> <strong>LinkedIn Learning</strong> also features practical case studies. For example, their Python Data Analyses course requires students to analyze the U.S. Social Security Baby Name dataset with the pandas library in Python to find the most common unisex names. <br> <br> Unfortunately, LinkedIn Learning’s Data Science and Data Analyst paths offer far fewer practical case studies and exercises than 365 Data Science’s curriculum.',
              },
              {
                name: 'Exams',
                text: 'Exams are perfect for students to test their theoretical and practical knowledge accumulated after a particular section or course. Passed examinations indicate to future employers that you have the necessary expertise to do your job well. <br> <br> <span class="highlight">365 Data Science</span> heavily focuses on examinations, offering three different types of exams. <br> <br> <strong>Practice Exams</strong> are optional and test your knowledge of a particular section/chapter of the course. They’re an excellent way to prepare for the course exams and help you identify potentially critical areas of improvement. <br> <br> <strong>Course Exams</strong> are comprehensive (timed) exams that test your level of expertise gained at the end of each course topic. <br> <br> <strong>Career Track Exams</strong> are comprehensive (timed) exams that test your knowledge gained from all the courses in each career track and are only accessible once you’ve passed all the course exams in the track. <br> <br> <strong>LinkedIn Learning,</strong> conversely, does not offer comprehensive exams on most of their courses, nor do they provide any equivalent of a career track exam—only optional practice quizzes that are the equivalent of practice exams.',
              },
              {
                name: 'Certificates',
                text: 'Perhaps, one of the most significant value propositions an online platform can offer to its students—besides quality content—are industry-recognized certificates. They signal to employers that candidates have the necessary technical skills and character traits for the job. <br> <br> Therefore, <span class="highlight">365 Data Science</span> replaced their Certificates of Completion—which required students to view the entire course content—with Certificates of Achievements, which requires students to successfully pass their course exam with a minimum grade of 60%. <br> <br> Career Track Certificates are granted to students who have successfully passed all their course exams in the track and the career track exam itself. <br> <br> This rigorous approach to earning a certificate gives them their job-market value and prepares students for the real-life problems they’re expected to solve. <br> <br> The majority of <strong>LinkedIn Learning</strong> Certificates are Certificate of Completion for most of their courses—the equivalent of a Certificate of Completion, which is granted upon completing the video content. <br> <br> LinkedIn Learning does not provide any equivalent to the Career Track Certificates. Some of their courses offer a CPE-accredited certificate where students must pass a course exam with a 70% or above. But it’s essential to note that completing the learning paths for data science, data analytics, and business analytics provides academic credits.',
              },
              {
                name: 'Q&A support',
                text: 'Studying online such a technical field as data science can be challenging and confusing. Therefore, providing a Q&A section where you can turn to instructors and peers whenever you get stuck on a concept or exercise is essential. <br> <br> Both <span class="highlight">365 Data Science</span> and <strong>LinkedIn Learning</strong> provide a Q&A Hub to their students. But 365 students get help from their peers and actively participating instructors in the hub, making it the better alternative.',
              },
              {
                name: 'Student Ratings',
                text: 'Both LinkedIn Learning and 365 Data Science have positive reviews on G2. But LinkedIn Learning has significantly more reviews, with a 4.4/5 rating from 565 reviews, while 365 Data Science boasts 4.8/5 from four reviews. <br> <br> Trustpilot gives <strong>LinkedIn Learning</strong> a surprising 2.0/5 from 50 reviews, with some customers complaining about its cancellation and money refund policy. <br> <br> <span class="highlight">365 Data Science</span> features an impressive 4.9/5 from 669 reviews, with positive reviews on its course structure and beginner friendliness.',
              },
              {
                name: 'Pros and Cons',
                text: '<div class="title-dots-1"><strong>LinkedIn Learning</strong></div><div>Pros:</div><ul class="dots"><li>Consistent, high-quality video production</li><li>Extensive library of courses on different topics</li><li>Academic Credits and CPE Accreditation</li></ul><div class="spacing">Cons:</div><ul class="dots"><li>Lack of graded exams</li><li>Some outdated courses</li><li>No instructor feedback/help</li><li>Lack of Certificates of Achievement</li></ul> <div class="highlight" class="highlight-text">365 Data Science</div><div class="title-dots-2">Pros:</div><ul class="dots"><li>Industry-recognized certificates</li><li>Beginner-friendly</li><li>Comprehensive career tracks</li><li>Plenty of learning resources</li></ul><div>Cons:</div><ul class="dots"><li>Lack of Portfolio Projects</li><li>Less business-related courses</li></ul>',
              },
              {
                name: 'Pricing',
                text: '<span class="highlight">365 Data Science</span> offers free content to students who wish to try the platforms’ teaching styles before deciding on a plan. The platform permits students access to the first chapters of each course and the resources and practice exams without a credit card—allowing them to upgrade. <br> <br> By now, you are probably wondering how much LinkedIn Learning costs? In terms of LinkedIn Learning’s pricing, they have a premium plan, but people can access a free trial for one month. When the trial expires, students’ credit cards are charged.  <br> <br> <div class="title-dots-1"><strong>LinkedIn Learning Pricing</strong></div><ul class="dots"><li><strong>Free subscription:</strong> One-month free access to all courses</li><li><strong>Premium:</strong> $19.00/month billed annually or $21.00/month</li></ul> <div class="highlight" class="title-dots-1">365 Data Science Pricing</div><ul class="dots"><li><strong>Free subscription:</strong> Access to the first few lessons of all courses</li><li><strong>Premium:</strong> $36/month or $29/month billed annually</li></ul>',
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs LinkedIn Learning',
            text: '365 Data Science is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later.<br><br>',
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoLinkedIn',
              planType: 'Premium',
              price: '$19.00',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs LinkedIn Learning: Which one to choose?',
            text: 'Choosing between the two platforms ultimately comes down to your needs and preferences. <p>Is <b>LinkedIn Learning</b> worth it? First, it might be a good option due to its vast library of thousands of courses if you think you need to learn a particular skill related to data science or business. And if you wish to go down the academic path, then some of the academically accredited courses might be best for you.</p> If you’re a beginner looking for an alternative to LinkedIn Learning, <span class="highlight">365 Data Science</span> might be the better platform for your career goals. 365 will help you build job-ready skills that will land you an entry-level position in data science. Each career track is built systematically, training your skills from beginner to advanced, with a heavy emphasis on practical skills. And as a testament to your expertise, you can earn an industry-recognized certificate at the end of the career track, providing you with a competitive advantage over other job candidates.',
          },
        },
        '/pluralsight-alternative-365-data-science/': {
          competitorName: 'Pluralsight',
          heroSection: {
            title: 'Pluralsight Alternative: 365 Data Science vs Pluralsight Comparison',
            subtitle: 'Why 365 Data Science Brings More Value to Beginner Data Science Students Course Content, Features, Pricing ',
            description: `<p>Are you considering a Pluralsight alternative? Why not contemplate how the 365 Data Science value proposition differs from Pluralsight? </p>
                          <p>Pluralsight is an online e-learning platform with an extensive library of over 7,000 courses on data science, digital business marketing, software development, and even creative classes taught by industry professionals in video format.</p>  
                          <p>At the same time, 365 Data Science’s structured and more beginner-friendly teaching methods better suit beginner and intermediate students’ learning needs. Its course curriculum offers a solid foundation that lets you comprehend the more challenging topics later—including applicable business principles and programming languages like SQL, R, Python, and Excel.</p>`,
          },
          firstSection: {
            title: 'Course Content: 365 Data Science vs Pluralsight',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later.<br><br>',
            subtitle: '365 Data Science',
            dataScienceText: `
            <p><b>365 Data Science’s</b> curriculum offers three career tracks: Data Scientist, Data Analyst, and Business Analyst. Each track starts with an Introduction to Data and Data Science—setting the foundation for the upcoming concepts and lessons.</p>
            <p>Each course is a logical continuation of the previous one and takes skill levels that have already been attained into consideration—making 365 Data Science ideal for beginners. You wouldn’t need to follow along with repeated explanations, for instance, merely because the course creators weren't sure if a particular idea had been covered in earlier lessons.</p>
            <p>All the Career Tracks cover the essential statistical principles needed for working with data. The Data Science career path also delves deeply into the advanced probability concepts required for students to become capable data scientists with computational thinking.</p>
            `,
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: '<b>Pluralsight</b> does not have Career Tracks but Learning Paths—designed to teach you a specific skill from beginning to end by combining distinct courses and tools into a single experience. Paths are also divided from beginner to advance to assist you in acquiring the appropriate abilities in the proper sequence. With 200+ Learning Paths covering such topics as Cloud, Software Development, Data Science, and Cyber Security, students have plenty to choose from.',
            competitorImage: 'pluralsight.jpg',
            competitorImageAlt: 'Screenshot from Pluralsight’s learning platform displaying part of its course content.',
            competitorImageTitle: 'Pluralsight Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: `<p>Like 365 Data Science, Pluralsight courses cover all the essential data science skills (machine learning, deep learning, data visualization, data processing, statistics) in popular technologies like Python, R, SQL, Tableau, and Excel.</p>
                      <p>With specialized learning paths like Data Science for Microsoft Azure, Pluralsight is a good platform for learning individual data science skills. Still, students who want a clear and structured roadmap to build job-ready skills in their chosen career role will find that 365 Data Science Career Paths will suit their needs better.</p>`,
          },
          secondSection: {
            title: 'Key Features: 365 Data Science vs Pluralsight',
            list: [
              {
                name: 'Learning Platform',
                text: `
                <p><span class="highlight">365 Data Science</span> acknowledges students’ challenges with online learning—such as a lack of engagement, accountability, motivation, or fun. To solve these concerns, the platform has gamified elements that promote beneficial learning practices. It also offers an experience points (XPs) system, newsfeed, collecting cards, and other features in addition to the standard learning dashboard where you establish goals and monitor your progress.</p>
                <p><b>Pluralsight</b>, on the other hand, does not offer gamified features but provides such interesting functions as Notes, which allow you to take study notes while watching a course. Students receive badges upon completing particular learning accomplishments like watch time, course completion, and learning streaks, which they can share on social media.</p>
                <p>The most useful Pluralsight platform feature includes the video download function, allowing you to watch videos offline.</p>
                `,
              },
              {
                name: 'Learning Material',
                text: `<p>Learning materials help students assimilate the subject matter quicker and in ways that course videos cannot. <span class="highlight">365 Data Science</span> offers downloadable resources that can be stored on your computer and accessed offline.</p>
                      <p>In addition to exercise files with videos, 365 Data Science offers a variety of other resources to satisfy the needs of students, such as:</p>
                <ul>
                  <li>Course Notes: This free feature offers PDF text documents that outline key ideas from a particular course.</li>
                  <li>Templates: These code-ready templates speed up your process and reduce online browsing time.</li>
                  <li>Infographics: These PDF documents include eye-catching graphics that help beginners explain the overall concept of the complicated field of data science.</li>
                </ul>
                <p>Pluralsight also offers downloadable resources that can be stored on your computer and accessed offline. It does not offer course notes but does provide guides—equivalent to 365 Data Science Templates. Guides are text-based articles that answer various coding projects and technology questions.</p>`,
              },
              {
                name: 'Real Environment Practice',
                text: `<span class="highlight">365 Data Science</span> and <b>Pluralsight</b> offer coding in real environments and video instructions on how to set it up. 
                        <br>
                        Although less practical than in-browser coding—which enables students to switch from video to coding without interruptions—the benefits of honing your abilities in a realistic setting outweigh the drawbacks by a wide margin.  
                        <br>
                        Businesses expect you to set up your own program and find solutions to practical issues. This method shows you how to resolve issues in a setting where browser-based coding is inadequate for handling large datasets.`,
              },
              {
                name: 'Practical Case Studies',
                text: `<p><span class="highlight">365 Data Science</span> emphasizes the business application of data science in its practical case studies.  It offers valuable case studies where students can put what they've learned into practice in a real-world setting. For instance, 365’s Probability Course uses actual data from Hamilton College and asks students to use the Bayesian Law to decide whether the institution successfully diversifies its student body.</p>
                      <p><b>The platform</b> highlights the business application of data science in its exercises and case studies in courses like the following: 
                      <ul>
                        <li>Python for Finance</li>
                        <li>Credit Risk Modeling in Python</li>
                        <li>Time Series Analysis in Python</li> 
                        <li>Ai Applications for Business Success</li>
                      </ul>
                      <p><b>Pluralsight</b> offers hands-on projects that help you build and deploy real-world applications using your own developer workspace. An example project includes Building Baseball Data Visualizations with Python, where students follow instructions to create data visualizations that present data on Major League Baseball All-Star Games.</p>`,
              },
              {
                name: 'Exams',
                text: `
                  <p>Exams are ideal for students to gauge how much theoretical knowledge and practical application they’ve retained from a section or course. Passed exams demonstrate to potential employers that you possess the necessary expertise to perform your job well.</p>
                  <p>The optional practice exams of <span class="highlight">365 Data Science</span> evaluate your understanding of a specific area or chapter of the course. They help you find potentially essential areas for improvement and are an excellent method to prepare for the course exams.</p>
                  <p>365’s Course Assessments are comprehensive (timed) exams that gauge how much knowledge you’ve acquired from each course.</p>
                  <p>Career Track Exams are accessible only once you’ve completed each course exam in the professional track and have had your knowledge assessed from every course in the career track.</p>
                  <p><b>Pluralsight</b> does not offer examinations for their courses—aside from Skill IQ, which assesses your level of knowledge in a given technology before beginning a Learning Path. They also include Role IQ, which evaluates your skill levels against the expertise your ideal career role requires.</p>
                `,
              },
              {
                name: 'Certificates',
                text: `<p>After completing a course or career track, a certificate from an online learning platform could be a crucial selling point for a prospective employee. The data science business places high value on certifications because they demonstrate that the individual possesses the character qualities and technical skills required to be a competitive job applicant.
                        <span class="highlight">365 Data Science</span> provides industry-recognized certificates that significantly increase students’ chances of landing a data science job. When passing exams with a grade of at least 60%, students can acquire two certificates: Course Certificates and Career Track Certificates.
                      </p>
                      <p>
                        <b>Pluralsight</b> does not offer an equivalent to 365’s Career Track Certificate. Instead, they offer a Certificate of Completion—students only need to go through the course content to receive a certificate. This certification, therefore, holds less value in the job market. It’s important to note that some of the Pluralsight Learning Paths prepare you for industry certifications and examinations in companies like Microsoft, Cisco, and Amazon. But they do not guarantee successful exam completion; you still must register and pay for your exams. (Neither 365 Data Science nor Pluralsight certificates require fees.)
                      </p>`,
              },
              {
                name: 'Q&A support',
                text: `
                <p><span class="highlight">365 Data Science</span> offers superb, personalized customer support, and instructors actively participate in responding to queries from the platform’s Q&A section. Such assistance is essential for novices when they require professional guidance.</p>
                <p>Pluralsight provides a Discussion Board under each course where students can receive peer help on specific questions related to the course. Unfortunately, Pluralsight students do not have access to specialized, professional assistance.</p>`,
              },
              {
                name: 'Student Ratings',
                text: `<p>Both <span class="highlight">365 Data Science</span> and <b>Pluralsight</b> reviews are positive on Trustpilot and G2. Pluralsight has significantly more reviews on G2, with 4.6/5 stars based on 901 reviews, while 365 Data Science has 4.8/5 from 5 reviews.</p>
                <p>On Trustpilot 365 Data Science scores an impressive 4.9 out of 5 stars based on 670 reviews, and Pluralsight scores a surprising 2.0 out of 5 stars out of 905 reviews with complaints regarding refunds and billing practices, as well as the difference in quality between the two Standard and Premium Pluralsight subscription tiers.</p>
                `,
              },
              {
                name: 'Pros and Cons',
                text: `
                <div class="highlight" class="highlight-text">365 Data Science</div>
                <div class="title-dots-2">Pros:</div>
                <ul class="dots">
                  <li>Structured Career Track curriculum</li>
                  <li>Comprehensive graded exams</li>
                  <li>Instructor and peer assistance</li>
                  <li>Recognized Certificates of Achievement</li>
                </ul>
                <div>Cons:</div>
                <ul class="dots">
                  <li>Less mobile-friendly experience</li>
                  <li>No guided projects </li>
                </ul>
                <div class="title-dots-1">
                  <strong>Pluralsight</strong>
                </div>
                <div>Pros:</div>
                <ul class="dots">
                  <li>Pluralsight mobile app</li>
                  <li>Offline video streaming</li>
                  <li>Diverse curriculum of software development and programming languages</li>
                </ul>
                <div class="spacing">Cons:</div>
                <ul class="dots">
                  <li>No exams</li>
                  <li>Lack of graded assignments </li>
                </ul>`,
              },
              {
                name: 'Pricing',
                text: `
                <p><span class="highlight">365 Data Science</span> and <b>Pluralsight</b> offer free content to students who want to taste the platforms’ teaching styles before deciding on a plan.</p>
                <p>365 allows students access to the first chapters of each course and the resources and practice exams in them. In this way, students have an excellent opportunity to decide if they want to upgrade.</p>
                <p>Pluralsight offers a lot of free content with over 50+ free Pluralsight courses, and the first few lessons of each course are also free.</p>
                <p>The Premium Pluralsight subscription tier gives access to the entire library of courses and exam prep for certifications, access to hands-on projects, and coding challenges—all of which are not accessible to Standard tier users.</p>
                <div class="highlight" class="highlight-text">365 Data Science Pricing</div>
                <ul class="dots">
                  <li><b>Free subscription:</b> access to the first few lessons of all courses</li>
                  <li><b>Premium:</b> $36/month or $29/month billed annually</li>
                </ul>
                <div class="highlight-text"><b>Pluralsight Pricing</b></div>
                <ul class="dots">
                  <li><b>Free subscription:</b> access to the first few lessons of all courses</li>
                  <li><b>Standart:</b> $29/month</li>
                  <li><b>Premium:</b> $45/month billed</li>
                </ul>`,
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs Pluralsight',
            text: '365 Data Science is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later.<br><br>',
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoPluralSight',
              planType: 'Premium',
              price: '$37.40',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: false,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs Pluralsight: Which one to choose?',
            text: `<p><b>365 Data Science</b> provides a more structured and approachable learning environment for beginner and intermediate students with its comprehensive video classes taught by subject matter experts (SMEs) and industry-recognized credentials. 365 is the best option if you're seeking a systematic curriculum and an entertaining platform that inspires you to learn and become job ready.</p>
                  <p><b>Pluralsight</b> is a good choice if you’re interested in learning various programming/coding languages like Azure, Java, or Linux—thanks to its extensive library of courses. So, if you’re interested in learning cyber security, web development—or other IT-related skills—then chances are Pluralsight has a course for that.</p>`,
          },
        },
        '/springboard-alternative-365-data-science/': {
          competitorName: 'Springboard',
          heroSection: {
            title: 'Springboard Alternative: 365 Data Science vs Springboard Comparison',
            subtitle: 'Why 365 Data Science Brings More Value to Beginner Data Science Students Course Content, Features, Pricing',
            description: 'Are you looking for a Springboard alternative? Springboard is an online data science bootcamp that bridges the skill gap by providing mentor-led online courses and bootcamps in data science, analytics, cyber security, software engineering, and UI/UX design. While 365 Data Science does not offer a personalized bootcamp experience, its teaching methods meet beginner data science students’ needs.',
          },
          firstSection: {
            title: 'Course Content: 365 Data Science vs Springboard',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum ensures a solid foundation that allows you to understand the more complicated topics later.<br><br>',
            subtitle: '365 Data Science',
            dataScienceText: `
            <p>The curriculum of <b>365 Data Science</b> offers three career tracks: Data Scientist, Data Analyst, and Business Analyst. Each track begins with an Introduction to Data and Data Science, setting the foundation for the upcoming concepts and lessons.</p>
            <p>Each course is a logical continuation of the previous one and considers skill levels already attained—making 365 Data Science especially ideal for beginners. For instance, you won't need to follow along with repeated explanations merely because the course creators needed to be sure if a particular idea had been covered in earlier lessons. The Data Science career path also delves deeply into the advanced probability concepts required for students to become capable data scientists with computational thinking. The essential statistical principles necessary for working with data are covered in the career tracks.</p>
            `,
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: '<p><b>Springboard</b> offers eight career tracks—three of which include Data Scientist, Machine Learning Engineer, and Data Analyst. Students can enroll for these career tracks on specific dates throughout the year. But spots are limited, and candidates are accepted on a rolling basis. All candidates must go through a multi-step application process that ends with an admission technical skill survey that determines if students are eligible for enrollment. Therefore, beginner data science students may opt for the Springboard prep course or Foundations to Core springboard courses which require no prerequisites and follow a similar structure to the Springboard career tracks.</p>',
            competitorImage: 'sprinboard.jpg',
            competitorImageAlt: 'Screenshot from Springboard’s learning platform displaying part of its course content.',
            competitorImageTitle: 'Springboard Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: `<p>Regarding content, Springboard and 365 Data Science are on the same page. Both curriculums teach essential statistical concepts, data visualization, and machine learning techniques—data wrangling in a structured fashion.</p>
            <p>While both e-learning platforms teach data visualization, the Springboard Data Science Career Track covers data visualization in Python only, while 365 Data Science’s The Complete Data Visualization Course teaches data visualization in Python, Excel, Tableau, and R.</p>`,
          },
          secondSection: {
            title: 'Key Features: 365 Data Science vs Springboard',
            list: [
              {
                name: 'Learning Platform',
                text: `  
                <p><span class="highlight">365 Data Science</span> acknowledges students’ difficulties with online learning, such as a lack of engagement, accountability, motivation, and fun. The platform includes gamified elements that promote wholesome learning practices to solve these concerns. It also provides an XP system, newsfeed, collecting cards, leaderboard, and other features—in addition to the typical learning dashboard where you establish goals and monitor your progress.</p>
                <p>On the other hand, <b>Springboard</b> does not offer gamified features that make your learning experience more fun, engaging, and competitive.</p>
                `,
              },
              {
                name: 'Learning Material',
                text: `<p>Learning materials help students assimilate the subject matter quicker and in ways that course videos cannot. <span class="highlight">365 Data Science</span> offers downloadable resources that can be stored on your computer and accessed offline.</p>
                <ul>
                  <li>In addition to exercise files with videos, 365 Data Science provides a variety of other resources to satisfy the needs of students, including: Course Notes – free PDF text documents that highlight the key concepts from a particular course.</li>
                  <li>Templates: code-ready templates that speed up your process and cut down on online browsing time.</li>
                  <li>Infographics: PDF documents with eye-catching pictures that assist newcomers in explaining the big picture of the challenging discipline of data science.</li>
                </ul>
                <p>On the other hand, <b>Springboard</b> does not offer downloadable learning material that students can use offline. They do provide practice exercises, career-related coursework, and articles.</p>`,
              },
              {
                name: 'Real Environment Practice',
                text: `<b>Springboard</b> and <span class="highlight">365 Data Science</span> offer coding in real environments and video instructions on how to set it up. 
                        <br>
                        Although less practical than in-browser coding—which allows students to transition from video to coding seamlessly—the advantages of developing your skills in a real-world environment far outweigh the disadvantages. All businesses assume you will create your own program and identify workable solutions to problems. Additionally, this approach demonstrates how to solve problems when browser-based code cannot handle massive datasets.`,
              },
              {
                name: 'Practical Case Studies',
                text: `<p><span class="highlight">365 Data Science</span> emphasizes the business application of data science in its practical case studies. It offers helpful case studies where students can put what they've learned into practice in a real-world setting.</p>
                      <p>For instance, the Probability Course in 365 Data Science gives you access to the FIFA 19 player stats dataset. As a head product manager—applying continuous distribution concepts—you must determine whether the game is well-balanced and enjoyable.</p> 
                      <p>365 Data Science highlights the business application of data science in its exercises and case studies in courses like Python for Finance.</p> 
                      <ul>
                        <li>Credit Risk Modeling in Python</li>
                        <li>Time Series Analysis in Python</li>
                        <li>AI Applications for Business Success</li> 
                      </ul>
                      <p><b>Springboard</b> offers multiple mini projects to their career tracks that reinforce the concepts you’ve learned in a practical setting and two capstone projects you can add to your portfolio. An example Springboard capstone project is cryptocurrency price prediction facilitated by article sentiment analysis. </p>`,
              },
              {
                name: 'Exams',
                text: `
                  <p>Exams are ideal for students to gauge how much knowledge they have retained from a given section or course regarding theory and application. Passed exams demonstrate to potential employers that you possess the necessary expertise to perform your job well.</p>
                  <p><span class="highlight">365 Data Science</span> optional practice exams evaluate your understanding of a particular area or chapter of the course. They help you find potentially essential areas for improvement and are an excellent method to prepare for the course exams.</p>
                  <p>Course assessments are thorough (timed) exams that gauge how much knowledge you have acquired on each course topic.</p>
                  <p>Career track exams are accessible only once you have completed every course exam in the professional track and assessed your knowledge from every course in the career track.</p>
                  <p><b>Springboard</b> does not offer final comprehensive exams equivalent to the career track exam. The only type of examination Springboard provides is their online technical survey skills which students must pass to enroll in a Springboard data science bootcamp.</p>
                `,
              },
              {
                name: 'Certificates',
                text: `<p>The certifications students receive from online learning platforms after completing a course or career track are key selling points. The data science business places a high value on certificates since they show that the student possesses the character qualities and technical skills required to be a competitive job applicant.
                        <span class="highlight">365 Data Science</span> provides industry-recognized certificates that significantly increase students’ chances of landing a data science job. When passing exams with a grade of at least 60%, students can obtain course certificates and career track certificates.
                      </p>
                      <p>
                        <b>Springboard</b> students receive certificates upon the completion of a Springboard career track. Students must review all the video lessons, course materials, and hands-on projects and pass the capstone project, which your mentor reviews.
                      </p>`,
              },
              {
                name: 'Q&A support',
                text: `
                <p><span class="highlight">365 Data Science</span> provides superb, personalized customer support, and instructors actively participate in responding to queries from the platform's Q&A section. Such assistance is essential for novices and when they require professional guidance.
                  <br>
                  The <b>Springboard</b> bootcamp also offers an excellent support system for students throughout the six-month learning experience, as students can turn for help to mentors in one-on-one calls. Additionally, they have access to an industry career coach and student advisor from start to course finish.</p>
                <p>The potential problem is that students lose access to the Springboard mentorship and other services after six months, while the 365 Data Science Annual Plan gives more flexibility to students with busier schedules.</p>`,
              },
              {
                name: 'Student Ratings',
                text: `<p><span class="highlight">365 Data Science</span> and <b>Springboard</b> are well-regarded by students and have positive reviews on Trustpilot. Springboard has 0 ratings on the G2 platform, while 365 Data Science has 4.8/5 from five reviews.</p>
                <p>Springboard scores an impressive 4.4/5 stars based on 226 reviews, and 365 Data Science boasts 4.9/5 out of 670 reviews.</p>
                `,
              },
              {
                name: 'Pros and Cons',
                text: `
                <div class="title-dots-1">
                  <strong>Springboard</strong>
                </div>
                <div>Pros:</div>
                <ul class="dots">
                  <li>One-on-one calls with mentor</li>
                  <li>Project-based curriculum</li>
                  <li>Career-advice services</li>
                </ul>
                <div class="spacing">Cons:</div>
                <ul class="dots">
                  <li>Very expensive</li>
                  <li>No graded comprehensive exams</li>
                  <li>No downloadable resources</li>
                  <li>No free content</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science</div>
                <div class="title-dots-2">Pros:</div>
                <ul class="dots">
                  <li>Structured Career Track curriculum</li>
                  <li>Comprehensive graded exams</li>
                  <li>Instructor-peer help</li>
                  <li>Recognized Certificates of Achievement</li>
                </ul>
                <div>Cons:</div>
                <ul class="dots">
                  <li>No capstone projects</li>
                  <li>No one-on-one mentorship</li>
                </ul>
                `,
              },
              {
                name: 'Pricing',
                text: `
                <p><span class="highlight">365 Data Science</span> provides free content to students who wish to taste the platforms’ teaching styles before deciding on a plan. 365 allows students access to the first chapters of each course and the resources and practice exams in them. In this way, students have an excellent opportunity to decide if they want to upgrade.</p>
                <p>Unfortunately, <b>Springboard</b> does not offer free content—meaning students cannot get a preview of Springboard’s teaching style. Springboard courses last six months, and students can pay per month or upfront and save 13% on tuition.</p>
                <p>The deferred tuition plan allows students to pay after they start a data science job within six months of graduating, charging $457/month in 36 monthly installments. There is a $700 deposit for enrollment.</p>
                <div class="highlight-text"><b>Springboard Pricing</b></div>
                <ul class="dots">
                  <li><b>Standart:</b> $1,890/month</li>
                  <li><b>Upfront Discount:</b> $9,900/ billed once</li>
                  <li><b>Deferred Tuition:</b> $457/month</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science Pricing</div>
                <ul class="dots">
                  <li><b>Free subscription:</b> access to the first few lessons of all courses</li>
                  <li><b>Premium:</b> $36/month or $29/month billed annually</li>
                </ul>`,
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs Springboard Overview',
            text: '<b>365 Data Science</b> is particularly suitable for beginner and intermediate students. The course curriculum offers a solid foundation for later comprehending more challenging topics, including beneficial business principles and programming languages like SQL, R, Python, and Excel.',
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogosSringboard',
              planType: 'Data Science Bootcamp',
              price: '$1,890',
              billed: 'billed monthly',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs Springboard: Which one to choose?',
            text: `<p><b>Springboard</b> is a great learning platform that can provide a high-quality data science bootcamp experience to individuals thanks to the access to a support system of mentors, career coaches, teaching assistants, and Springboard student advisors. Like 365 Data Science, the career track-based learning ensures students follow a systematic learning approach. The capstone projects are a significant addition to your portfolio and a great way to practice what you’ve learned.</p>
            <p>While <b>365 Data Science</b> does not provide such a personalized learning style or capstone projects, it compensates for much more accessible content in terms of price and time flexibility. Each professional path is developed methodically—taking you from beginning to high skill levels while strongly emphasizing practical skills. At the end of the career track, you can acquire an industry-recognized certificate to prove your proficiency, giving you an advantage over other job applicants.</p>`,
          },
        },
        '/treehouse-alternative-365-data-science/': {
          competitorName: 'Treehouse',
          heroSection: {
            title: 'Treehouse Alternative: 365 Data Science vs Treehouse Comparison',
            subtitle: 'Why 365 Data Science Brings More Value to Beginner Data Science Students Course Content, Features, Pricing',
            description: 'Are you looking for a Treehouse alternative? Treehouse is an e-learning platform offering an online bootcamp experience to those looking to break into tech by providing online courses in data science, web development, software engineering, and UI/UX design. While 365 Data Science does not offer an online bootcamp venture, its accessibility and teaching style is more suitable for students starting in data science.',
          },
          firstSection: {
            title: 'Course Content: 365 Data Science vs Treehouse',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum offers a strong foundation that lets you comprehend the more challenging topics later, including applicable business principles and programming languages like SQL, R, Python, and Excel and data visualization tools like Tableau.',
            subtitle: '365 Data Science',
            dataScienceText: `
            <p>The 365 Data Science curriculum offers three career tracks: Data Scientist, Data Analyst, and Business Analyst. Each track begins with an Introduction to Data and Data Science, laying the foundation for the upcoming concepts and lessons.</p>
            <p><b>365 Data Science</b> is especially suitable for novices because each session is a logical continuation of the previous one and considers skill levels already obtained. For example, you won't need to listen to repeated explanations only because the course's designers must be sure if a specific concept has been taught in prior courses. The Data Science career path also delves deeply into the advanced concepts in deep learning and probability required for students to become capable data scientists with computational thinking. The essential statistical principles necessary for working with data are covered in the career tracks.</p>
            `,
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: `<p>Treehouse Tracks are designed to help you master specific skills via a structured series of courses and workshops. Treehouse offers 45 tracks on various tech topics—five related to data science. None include the more advanced concepts like deep learning with TensorFlow or data visualization in R and Tableau, which are covered in the 365 Data Science curriculum. The Treehouse curriculum does not provide courses on Tableau, R, or Power BI—essential technologies for data professionals.
                          <br> Students who wish to build-job ready skills can enroll for Treehouse Techdegrees, equivalent to 365 Data Science Career Track. Currently, Treehouse offers six Techdegree online boot camp programs—one of which is the Data Analysis program.  
                          <br> Since the Data Analysis Techdegree curriculum is a selected compilation of courses from the Treehouse library, it faces the same content gaps. But the Treehouse Techdegree differs from the 365 Career Tracks in its more project-based approach.</p>`,
            competitorImage: 'treehouse.jpg',
            competitorImageAlt: 'Screenshot from Treehouse’s learning platform displaying part of its course content.',
            competitorImageTitle: 'Treehouse Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: '',
          },
          secondSection: {
            title: 'Key Features: 365 Data Science vs Springboard',
            list: [
              {
                name: 'Learning Platform',
                text: `<p><span class="highlight">365 Data Science</span> recognizes students’ challenges with online learning, such as a lack of engagement, accountability, motivation, and fun. The platform has gamified elements to solve these concerns that promote engaging learning practices. The platform offers an XP system, newsfeed, collecting cards, leaderboard system, other features, and the standard learning dashboard where you establish goals and monitor your progress.</p>
                <p>On the other hand, <b>Treehouse</b> offers no gamified features apart from a graph that presents your study activity for the last seven days. Their videos, however, have clickable time stamp transcripts and are downloadable, which is great for offline use.</p>`,
              },
              {
                name: 'Learning Material',
                text: `<p>Learning materials help students assimilate the subject matter quicker and in ways that course videos cannot. <span class="highlight">365 Data Science</span> provides downloadable resources that can be stored on your computer and accessed offline.</p>
                      <p>In addition to exercise files with videos, 365 Data Science offers a variety of other resources to satisfy the needs of students, such as the following:</p>
                <ul>
                  <li>Course Notes: free PDF text documents highlighting a particular course's key concepts .</li>
                  <li>Templates: code-ready templates that speed up your process and cut down on online browsing time.</li>
                  <li>Infographics: PDF documents with eye-catching graphics that assist newcomers in explaining the big picture of the challenging discipline of data science.</li>
                </ul>
                <p><b>Treehouse</b> courses also offer external learning resources and content linked to educational articles, cheat sheets, and working files that students can download.</p>`,
              },
              {
                name: 'Real Environment Practice',
                text: `<p><span class="highlight">365 Data Science</span> offers coding in real environments and video instructions on how to set it up.</p>
                      <p>Although less practical than in-browser coding—which allows students to transition from video to coding—developing your skills in a real-world environment far outweighs the disadvantages. All businesses assume you’ll create your own program and identify workable solutions to problems. Additionally, this approach demonstrates how to solve problems when browser-based code cannot handle massive datasets.</p>
                      <p>While <b>Treehouse</b> also encourages coding in real environments, they have Workspaces (browser-based code editors) that students can save whenever they follow along with the video material. Each Workspace, however, only has a limited 50 MB but can have up to 100 Workspaces created at a time.</p>`,
              },
              {
                name: 'Practical Case Studies',
                text: `<p><span class="highlight">365 Data Science</span> emphasizes the business application of data science in its practical case studies. It offers helpful case studies where students can put what they've learned into practice in a real-world setting.<br>As an illustration, the Probability Course in 365 Data Science provides access to the FIFA 19 player stats dataset. As the game's head product manager, you must use continuous distribution concepts to assess whether the game is fair and fun to play.</p>
                      <p><b>365 Data Science</b> highlights the business application of data science in its exercises and case studies in such courses as:</p> 
                      <ul>
                        <li>Python for Finance</li>
                        <li>Credit Risk Modeling in Python</li>
                        <li>Time Series Analysis in Python</li> 
                        <li>AI Applications for Business Success</li> 
                      </ul>
                      <p>As previously mentioned, the <b>Treehouse</b> Techdegree program emphasizes practical projects and hands-on exercises as the Data Analysis Techdegree curriculum is divided into eight sections. Each section contains a real-world project students must complete and can add to their portfolios. One of the mandatory Treehouse projects requires students to analyze Olympic data from 1896 to 2016, using Google Sheets to compute statistics, apply conditional formatting, and so on.<br>Treehouse’s peer-review system for projects means that students review and grade each other’s work, which can be problematic because your grade can be delayed or affected by an unprofessional or prejudiced opinion.</p>`,
              },
              {
                name: 'Exams',
                text: `
                  <p>Exams are ideal for students to gauge how much knowledge they have retained regarding theory and application from a given section or course. Passed exams demonstrate to potential employers that you possess the necessary expertise to perform your job well.</p>
                  <p><span class="highlight">365 Data Science</span> хas three types of exams–practice exams, course exams and career track exams.</p>
                  <p>Optional practice exams evaluate your understanding of a particular area or chapter of the course. They help you find potentially essential areas for improvement and are an excellent method to prepare for the course exams.</p>
                  <p>Course assessments are thorough (timed) exams that gauge how much knowledge you have acquired on each course topic.</p>
                  <p>Career track exams are accessible only once you have completed every course exam in the professional track and have had your knowledge accessed from every course in the career track.</p>
                  <p><b>Treehouse</b> offers coding challenges, short practice quizzes equivalent to the 365 Practice Exams, and a Final Comprehensive Exam at the end of each Techdegree.</p>
                `,
              },
              {
                name: 'Certificates',
                text: `<p>The certifications students receive from online learning platforms after completing a course or career track are key selling points. The data science business places a high value on certificates since they show that the student possesses the character qualities and technical skills required to be a competitive job applicant.
                        <span class="highlight">365 Data Science</span> provides industry-recognized certificates that significantly increase students’ chances of landing a data science job. When passing exams with a grade of at least 60%, students can obtain course certificates and career track certificates.
                      </p>
                      <p>
                        <b>Treehouse</b> students receive certificates upon completing all the coursework, including all the projects, and passing the final exam. Students can save their certification via Accredible (a digital credentialing solution). Unfortunately, as previously noted, the peer review system can cause potential problems because your grade relies upon someone else’s diligence and judgment. While Treehouse tries to address this issue by providing workshops to students on how to critique work, nothing can replace a professional evaluation.
                      </p>`,
              },
              {
                name: 'Q&A support',
                text: `
                <p><span class="highlight">365 Data Science</span> provides superb, personalized customer support, and instructors actively participate in responding to queries from the platform's Q&A section. Such assistance is essential for novices and when they require professional guidance.
                  <br><br>
                  The <b>Treehouse</b> learning platform features a Q&A forum and a Slack community of like-minded peers and staff assistants to help you throughout the course. Unfortunately, Treehouse instructors do not participate in these discussions. All students enrolled in the Tech degree get a one-time 30-minute free call with the Treehouse CEO, where they can discuss career advice and any other questions they have.`,
              },
              {
                name: 'Student Ratings',
                text: `<p><span class="highlight">365 Data Science</span> and <b>Team Treehouse</b> are well-regarded by students and have positive reviews on Trustpilot and G2. Treehouse scores 4.3/5 stars based on 37 reviews on the G2 platform, while 365 Data Science has 4.8/5 from five reviews.</p>
                <p>Treehouse has 4.1/5 stars based on 11 reviews, and 365 Data Science boasts 4.9/5 from 670 reviews.</p>
                `,
              },
              {
                name: 'Pros and Cons',
                text: `
                <div class="title-dots-1">
                  <strong>Treehouse</strong>
                </div>
                <div>Pros:</div>
                <ul class="dots">
                  <li>Project-based curriculum</li>
                  <li>Downloadable videos</li>
                  <li>Techdegrees in different IT fields</li>
                </ul>
                <div class="spacing">Cons:</div>
                <ul class="dots">
                  <li>Outdated or incomplete data science curriculum</li>
                  <li>Peer review system</li>
                  <li>Noticeable difference in quality between the different subscriptions</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science</div>
                <div class="title-dots-2">Pros:</div>
                <ul class="dots">
                  <li>Comprehensive career track curriculum</li>
                  <li>Instructor-peer help</li>
                  <li>Gamified learning platform</li>
                  <li>Recognized Certificates of Achievement</li>
                </ul>
                <div>Cons:</div>
                <ul class="dots">
                  <li>No Real-World Projects</li>
                  <li>No 1-on-1 mentorship</li>
                </ul>
                `,
              },
              {
                name: 'Pricing',
                text: `
                <p><span class="highlight">365 Data Science</span> provides free content to students who wish to taste the platforms’ teaching styles before deciding on a plan. It allows students access to the first chapters of each course and the resources and practice exams in them. In this way, students have an excellent opportunity to decide if they want to upgrade.</p>
                <p><b>Treehouse</b> also offers a lot of free content in the form of a seven-day free trial where you can audit entire course content and tracks without having access to the graded projects or exams.</p>
                <p>It’s important to note that students do not get access to real-world projects, the Slack community, career advice, or other benefits in the basic Treehouse subscription courses and Courses Plus.</p>
                <div class="highlight-text"><b>Treehouse Pricing</b></div>
                <ul class="dots">
                  <li><b>Free:</b> 7-day free trial to all courses</li>
                  <li><b>Courses:</b> $25/month</li>
                  <li><b>Courses Plus:</b> $49/ billed month</li>
                  <li><b>Techdegree:</b> $199/month</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science Pricing</div>
                <ul class="dots">
                  <li><b>Free subscription:</b> access to the first few lessons of all courses</li>
                  <li><b>Premium:</b> $36/month or $29/month billed annually</li>
                </ul>`,
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs Treehouse',
            text: '<b>365 Data Science</b> is particularly suitable for beginner and intermediate students. The course curriculum offers a solid foundation for later comprehending more challenging topics, including beneficial business principles and programming languages like SQL, R, Python, and Excel.',
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoTreehouse',
              planType: 'Courses Plus',
              price: '$49.00',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs Treehouse: Which one to choose?',
            text: `<p><b>Springboard</b> is a learning platform that has a lot of interesting real-world projects. The lack of a professional support system, one-on-one mentorships, and a comprehensive curriculum covering all the technologies and advanced concepts might provide a lesser online data science bootcamp experience than 365. If you wish to learn a specific skill, then 365’s courses in web development, UX, UI design, and other IT-related skills might suit you better.</p>
            <p>If you’re looking to build your skills from the ground up and land a job in data science, the <b>365 Data Science</b> Curriculum is the right choice. Each career track explains concepts of all levels in an easy-to-understand manner, covering all the technologies and skills you need while emphasizing practical skills. At the end of the career track, you can acquire an industry-recognized certificate to prove your proficiency, giving you an advantage over other job applicants.</p>`,
          },
        },
        '/edx-alternative-365-data-science/': {
          competitorName: 'edX',
          heroSection: {
            title: 'edX Alternative: 365 Data Science vs edX Comparison',
            subtitle: 'Why 365 Data Science Brings More Value to Beginner Data Science Students Course Content, Features, Pricing',
            description: `<p>Are you searching for an edX alternative? Consider how the 365 Data Science value proposition differs from that of edX.</p>
                    <p>edX online courses are taught by university professors and industry professionals in video format. As a well-established online e-learning platform, edX delivers courses in data science, computer science, finance, and social sciences.</p>
                    <p>While edX offers a broader selection of courses—some of which are college accredited—365 Data Science’s self-paced learning experience and structured career tracks might better suit beginner students’ learning needs.</p>`,
          },
          firstSection: {
            title: 'Course Content: 365 Data Science vs edX',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum offers a strong foundation that lets you comprehend the more challenging topics later, including applicable business principles and programming languages like SQL, R, Python, and Excel and data visualization tools like Tableau.',
            subtitle: '365 Data Science',
            dataScienceText: `
            <p>The curriculum of <b>365 Data Science</b> offers three career tracks: Data Scientist, Data Analyst, and Business Analyst. Each track consists of 10 courses (with two electives), and all start with Introduction to Data and Data Science—which sets the foundation for the upcoming concepts and lessons.</p>
            <p>365 Data Science is especially suitable for novices because each session is a logical continuation of the previous one and considers skill levels already obtained. For example, you won't need to listen to repeated explanations only because the course's creators needed to be sure if a specific concept had been covered in prior courses. The career tracks teach the fundamental statistical concepts required for data work. The career path for data scientists also goes in-depth on advanced probability ideas needed for students to develop into competent data scientists with computational thinking.</p>
            `,
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: `<p>While edX has over 2,500 courses on a wide range of topics taught by university professors from institutions and top organizations like Harvard, MIT, IBM, and Amazon Web Services (AWS), beginner students can feel overwhelmed by the sheer number of courses.<br>
                            edX does offer professional certificate programs that help students build the necessary professional skills in a given area via a series of bundled certified edX online courses.</p>
                            <p>While the edX data science curriculum is on the same page with 365 Data Science regarding essential data science skills, none of the professional certificate programs offer interview and job preparation courses.</p>
                            <p>On the other hand, 365 Data Science teaches valuable soft skills and best job-landing practices in the SQL for Data Science Interview and Starting a Career in Data Science courses.<br<p
                            It’s also important to note that edX’s data science professional certificate programs teach only some of the essential data skills in one place. The Harvard edX courses in its Data Science Professional Certificate program cover data science skills exclusively for R. IBM’s data science program teaches data visualization only in Python and omits essential mathematics and statistics courses.</p>`,
            competitorImage: 'edx.jpg',
            competitorImageAlt: 'Screenshot from edX’s learning platform displaying part of its course content.',
            competitorImageTitle: 'edX Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: '',
          },
          secondSection: {
            title: 'Key Features',
            list: [
              {
                name: 'Learning Platform',
                text: `<p><span class="highlight">365 Data Science</span> acknowledges students’ online learning challenges, such as a lack of engagement, accountability, motivation, and fun. The software contains gamified components that support beneficial learning practices to address these issues. The website provides additional elements beyond the standard learning dashboard where you set goals and track your progress, such as an XP system, newsfeed, collecting cards, and others.</p>
                <p><b>edX</b>, on the other hand, does not offer gamified features, and its platform design and features need to be updated and more user-friendly to navigate. It provides standard platform features like goal setting, course progress, and grade tracking. The most useful edX platform function is the ability to download transcripts and the videos themselves for offline usage.</p>`,
              },
              {
                name: 'Learning Material',
                text: `<p>Learning aids facilitate quicker and more effective assimilation of the material than course videos. Downloadable materials kept on your computer and accessed offline are available from 365 Data Science and edX.</p>
                      <p>In addition to exercise files with videos, 365 Data Science offers a variety of other resources to satisfy the needs of students, including the following:</p>
                <ul>
                  <li>Course Notes: free PDF text documents highlighting a particular course's key concepts.</li>
                  <li>Templates: code-ready templates that speed up your process and cut down on online browsing time.</li>
                  <li>Infographics: PDF documents with eye-catching graphics that assist newcomers in explaining the big picture of the challenging discipline of data science.</li>
                </ul>
                <p><b>edX</b> classes, in comparison, offer fewer learning materials with no templates or infographics. But they provide reading material with some programs, such as e-textbooks (equivalent to 365 course notes) and links to external online articles.</p>`,
              },
              {
                name: 'Real Environment Practice',
                text: `<p><b>edX</b> and <span class="highlight">365 Data Science</span> offer coding in real environments and video instructions on how to set it up.</p>
                      <p>Although less practical than in-browser coding—which allows students to transition from video to coding—developing your skills in a real-world environment far outweighs the disadvantages. All businesses assume you’ll create your own program and identify workable solutions to problems. Additionally, this approach demonstrates how to solve problems when browser-based code cannot handle massive datasets.</p>`,
              },
              {
                name: 'Practical Case Studies',
                text: `<p><span class="highlight">365 Data Science</span> emphasizes the business application of data science in its practical case studies. It offers helpful case studies where students can put what they've learned into practice in a real-world setting.</p>
                      <p>For instance, the Probability Course in 365 Data Science uses actual data from Hamilton College and asks students to use the Bayesian Law to decide whether the institution successfully diversifies its student body.</p> 
                      <p>365 Data Science highlights the business application of data science in its exercises and case studies in such courses as:</p> 
                      <ul>
                        <li>Python for Finance</li>
                        <li>Credit Risk Modeling in Python</li>
                        <li>Time Series Analysis in Python</li> 
                        <li>AI Applications for Business Success</li> 
                      </ul>
                      <p>edX, on the other hand, offers interesting hands-on projects you can work on as part of a Certificate Program Capstone or an individual course designed to put your skills to practice. An example edX capstone project involves MovieLens, where you must create a movie recommendation system using the MovieLens data set.</p>
                      <p>But all these graded projects are peer-graded—meaning you depend on others' abilities to meet deadlines and might receive a poorer grade based on an unprofessional, prejudiced judgment. </p>`,
              },
              {
                name: 'Exams',
                text: `
                  <p>Exams are ideal for students to gauge how much knowledge they have retained regarding theory and application from a given section or course. Passed exams demonstrate to potential employers that you possess the necessary expertise to perform your job well.</p>
                  <p><span class="highlight">365 Data Science</span> provides the opportunity to test the skills you have acquired with 3 types of timed online exams–Practice Exams, Course Exams, and Career Track Exams.</p>
                  <p>Optional practice exams evaluate your understanding of a particular area or chapter of the course. They help you find potentially essential areas for improvement and are an excellent method to prepare for the course exams.</p>
                  <p>Course assessments are thorough (timed) exams that gauge how much knowledge you have acquired on each course topic.</p>
                  <p>Career track exams are accessible only once you have completed every course exam in the professional track and have had your knowledge accessed from every course in the career track.</p>
                  <p><b>edX</b> offers Comprehension Checks at the end of each section which tests your knowledge of the concepts covered. It also includes ungraded comprehension checks—similar to 365 Data Science practice exams—allowing you to practice without consequence.</p>
                  <p>EdX also offers comprehensive assessments where students get graded on the accumulated material from the course via various exercises and questions.</p>
                `,
              },
              {
                name: 'Certificates',
                text: `<p>The certificates students receive from online learning platforms after completing a course or career track are key selling points. The data science industry places a high value on certificates since they show that the student possesses the character qualities and technical skills required to be a competitive job applicant.</p>
                      <p><span class="highlight">365 Data Science</span> provides industry-recognized certificates that significantly increase students’ chances of landing a data science job. When passing exams with a grade of at least 60%, students can obtain course certificates and career track certificates.</p>
                      <p><b>edX</b> offers verified certificates for course completion from a given track but does not have equivalents to a 365 Data Science Career Track Certificate. To earn an edX certificate, students must pass a course with a minimum grade of 70%.</p>
                      <p>It’s important to note that all edX courses have a beginning and end date by which the graded assignments and courses must be completed. This deadline system makes it more likely that you’ll depend on others' abilities to meet deadlines. And the peer-to-peer edX review system opens the possibility of receiving a poorer grade based on an unprofessional, prejudiced judgment.</p>`,
              },
              {
                name: 'Q&A support',
                text: `
                <p><span class="highlight">365 Data Science</span> provides superb, personalized customer support, and instructors actively participate in responding to queries from the platform's Q&A section. Such assistance is essential for novices and when they require professional guidance.</p>
                  <p><b>edX</b> doesn't include its professors in the discussion boards—so students are left without expert advice when encountering problems understanding a particular idea from a course.`,
              },
              {
                name: 'Student Ratings',
                text: `<p><span class="highlight">365 Data Science</span> and edX are well-regarded by students and have positive reviews on Trustpilot and G2. edX scores 4.5/5 stars based on 104 reviews, while 365 Data Science boasts 4.8/5 from five reviews.</p>
                <p>Trustpilot gives 365 Data Science an impressive 4.9/5 out of 670 reviews, with positive reviews regarding the easy-to-follow lessons, well-structured curriculum, and supportive learning environment.</p>
                <p><b>edX</b>, on the other hand, scores 3.0/5 stars based on 1,271 reviews, with negative feedback regarding the surprising lack of quality in its teaching, customer support, edX peer review, and deadline system.</p>
                `,
              },
              {
                name: 'Pros and Cons',
                text: `
                <div class="title-dots-1">
                  <strong>edX</strong>
                </div>
                <div>Pros:</div>
                <ul class="dots">
                  <li>Capstone and graded projects</li>
                  <li>Diverse curriculum of software development and programming languages</li>
                </ul>
                <div class="spacing">Cons:</div>
                <ul class="dots">
                  <li>Deadlines</li>
                  <li>Peer review system</li>
                  <li>Expensive</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science</div>
                <div class="title-dots-2">Pros:</div>
                <ul class="dots">
                  <li>Structured career track curriculum</li>
                  <li>Comprehensive graded exams</li>
                  <li>Instructor-peer help</li>
                </ul>
                <div>Cons:</div>
                <ul class="dots">
                  <li>No capstone projects</li>
                  <li>Currently no courses on Microsoft Azure or AWS</li>
                </ul>
                `,
              },
              {
                name: 'Pricing',
                text: `
                <p><b>edX</b> and <b>365 Data Science</b> provide free content to students who want to taste the platforms’ teaching styles before deciding on a plan. 365 Data Science allows students access to the first chapters of each course and the resources and practice exams in them. In this way, students have an excellent opportunity to decide if they want to upgrade.</p>
                <p>Regarding free courses, edX’s audit tracks allow students to view a significant portion of the course for free. Access to the graded assignments and verified edX certifications are granted to those who upgrade to a paid verified track.</p>
                <div class="highlight-text"><b>edX Pricing</b></div>
                <ul class="dots">
                  <li><b>Audit mode:</b> temporary access to non-graded activities and videos</li>
                  <li><b>Individual courses:</b> $50 – $300</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science Pricing</div>
                <ul class="dots">
                  <li><b>Free subscription:</b> access to the first few lessons of all courses</li>
                  <li><b>Premium:</b> $36/month or $29/month billed annually</li>
                </ul>`,
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs edX',
            text: '<b>365 Data Science</b> is particularly suitable for beginner and intermediate students. The course curriculum provides a solid comprehension of subsequent challenging topics, including applicable business principles and programming languages like SQL, R, Python, and Excel.',
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoEdx',
              planType: 'Individual courses',
              price: '$50-$300',
              pricePer: 'per course',
              billed: 'Billed per course',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs edX: Which one to choose?',
            text: `<p><b>edX</b> provides a more extensive library of courses on many programming languages and tools for data science that top industry experts and professors from prestigious universities teach. The capstone projects can be an excellent addition to your data science portfolio.</p>
            <p>But suppose you’re a beginner in the field of data science who is searching for a structured A-Z curriculum that covers beginner-advanced concepts. In that case, <b>365 Data Science</b> can offer a superior learning experience—the vibrant community of peers and instructor-student help</p>
            <p>365 Data Science provides a truly organized, self-paced learning environment. What 365 Data Science lacks in brand name and courses compared to edX, it compensates with a well-thought-out beginner-friendly curriculum. Additionally, you pay almost nothing for excellent content thanks to reasonable pricing and regular promotions. The program aids in developing marketable skills for a fraction of the price compared to edX.</p>`,
          },
        },
        '/simplilearn-alternative-365-data-science/': {
          competitorName: 'Simplilearn',
          heroSection: {
            title: 'Simplilearn Alternative: 365 Data Science vs Simplilearn Comparison',
            subtitle: 'Why 365 Data Science Brings More Value to Beginner Data Science Students Course Content, Features, Pricing',
            description: 'Simplilearn is оne of the world’s leading bootcamp providers. The learning platform offers self-paced and instructor-led courses with flexible schedules on topics like cyber security, digital marketing, business analytics, cloud computing, project management, and AI. 365 Data Science is an online self-paced learning platform focusing solely on data science and related topics, such as machine learning, deep learning, and data visualization. Instead of bootcamps, 365 offers structured career tracks that prepare you for data science, data analytics, and business analytics jobs. The platform, therefore, is more suitable for learning data science than Simplilearn.',
          },
          firstSection: {
            title: 'Course Content: 365 Data Science vs Simplilearn',
            text: '<strong>365 Data Science</strong> is particularly suitable for beginner and intermediate students. The course curriculum offers a strong foundation that lets you comprehend the more challenging topics later, including applicable business principles and programming languages like SQL, R, Python, and Excel and data visualization tools like Tableau.',
            subtitle: '365 Data Science',
            dataScienceText: `<p>The 365 Data Science platform is designed for beginners to advanced professionals, providing a comprehensive and in-depth learning experience. Its program curriculum offers three career tracks: Data Scientist, Data Analyst, and Business Analyst. Each track begins with an Introduction to Data and Data Science, laying the foundation for the upcoming concepts and lessons. 365 also provides learners access to tools and software commonly used in the industry, such as Python and SQL.</p>
            <p>The courses on 365 Data Science are taught by industry experts with years of experience in the field. The courses are structured into modules that build on each other and include video lectures, quizzes, and hands-on exercises. Additionally, learners are provided with interactive content—such as coding challenges and projects—that allows them to apply their knowledge in real-world scenarios. The Data Scientist career track also delves deeply into the advanced concepts in deep learning and probability required for students to become capable data scientists with computational thinking. The essential statistical principles necessary for working with data are presented in the career tracks.</p>`,
            dataScienceImage: 'data-camp-img1.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: '<p>Simplilearn provides courses on various subjects, such as cybersecurity, digital marketing, business analytics, cloud computing, project management, and AI. The platform is not solely focused on data science and is less comprehensive than 365. Simplilearn LMS offers data science training suitable for beginners with little or no prior knowledge in the field. Its courses are structured into modules, and each one contains video lectures, quizzes, and assignments. Simplilearn’s Data Science with Python course, for example, addresses the basics of data science, statistical analysis, and Python programming. It also includes hands-on projects, case studies, and practical exercises that help learners better understand and apply the concepts in real-world scenarios.</p>',
            competitorImage: 'simplilearn.jpg',
            competitorImageAlt: 'Screenshot from Simplilearn’s learning platform displaying part of its course content.',
            competitorImageTitle: 'Simplilearn Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: '',
          },
          secondSection: {
            title: 'Key Features: 365 Data Science vs Simplilearn',
            list: [
              {
                name: 'Learning Platform',
                text: `<p><b>365 Data Science</b> aims to prepare students for their first role in data science—even if they have little or no experience in the field. The platform emphasizes practical skills development and provides learners with numerous opportunities to practice and apply their knowledge—allowing them to develop the skills they need to succeed in their careers. Those who have already begun their career can take advantage of courses focusing on applying data science to business and prepare for a managerial position.</p>
                <p>365 has gamified elements that motivate students and create an engaging learning experience. Students collect XPs and cards with hand-drawn portraits of science pioneers, set goals and monitor their progress on a dashboard, compete for the top places on the leaderboard, communicate via the newsfeed, receive benefits and rewards for their achievements, etc.</p>
                <p><b>Simplilearn</b> doesn’t have a uniform course structure but offers several types of training (live classes, self-paced programs, etc.) in different formats and with various supplementary materials.</p>
                <p><b>Simplilearn's</b> LMS also includes progress tracking and personalized learning dashboards that help learners stay motivated and on track with their learning goals. But it lacks 365’s gamified elements and community of engaged students, which instill a sense of accountability and competitiveness that keeps you from quitting.</p>`,
              },
              {
                name: 'Learning Material',
                text: `<p><b>365 Data Science</b> courses include engaging video lessons with supplementary downloadable study materials and exercises.</p>
                      <p>In addition, 365 offers various free downloadable resources you can store on your computer and access offline, including the following:</p>
                <ul>
                  <li>Course Notes: free PDF text documents highlighting a particular course's key concepts.</li>
                  <li>Templates: code-ready templates that speed up your process and cut down on online browsing time.</li>
                  <li>Infographics: PDF documents with eye-catching graphics that assist newcomers in explaining the big picture of the challenging discipline of data science.</li>
                  <li>Practice exams: free exams to practice and test your skills.</li>
                  <li>Free guides and tutorials: PDF documents, blog articles, and step-by-step guides on various data science topics.</li>
                </ul>
                <p><b>Simplilearn</b> provides learners with downloadable resources, such as eBooks, whitepapers, case studies, and study materials. These resources vary per course and can be accessed from the learner's account and downloaded offline. The videos of the self-paced courses can also be downloaded and used after the completion of the course.</p>`,
              },
              {
                name: 'Real Environment Practice',
                text: `<p><b>365 Data Science</b> offers coding in real environments and video instructions on how to set it up. Practicing coding in a real-world environment may not be as convenient as using in-browser coding that enables students to switch quickly from watching a video to coding. But the benefits of developing your skills in a real-world environment outweigh the drawbacks. Most employers expect their employees to create their own programs and find practical solutions to problems. Moreover, this approach teaches you how to tackle issues not handled by browser-based coding, especially with large datasets.</p>
                <p><b>Simplilearn’s</b> platform provides learners access to various data science tools and software commonly used in the industry, such as Python, R, Tableau, and Excel. Its data science courses include hands-on projects that require learners to work with real datasets, clean and analyze the data, and present their findings using data visualization tools in their practice labs. These labs allow students to practice their coding skills as they are taught and provide instant feedback without the need for set-up, downloads, or extra software.</p>`,
              },
              {
                name: 'Practical Case Studies',
                text: `<p><b>365 Data Science</b> focuses on the practical application of data science in business through its case studies. The platform provides valuable case studies that enable students to put their learning into practice in a real-world environment. For instance, 365’s Probability course gives students access to the FIFA 19 player statistics dataset. The course challenges them to use—as if they were the head product manager of the game—continuous distribution concepts to evaluate if the game is fair and entertaining. Moreover, 365 emphasizes the practical application of data science to business through courses like Python for Finance, Credit Risk Modeling in Python, Time Series Analysis in Python, and AI Applications for Business Success.</p>
                <p><b>Simplilearn</b> also offers practical case studies for learners to apply their knowledge in real-world scenarios. For example, its Data Science with Python course includes a case study that analyzes data from a telecom company. The study requires learners to use data-cleaning techniques, perform exploratory data analysis, and build predictive models to identify critical insights to improve the company's performance.</p>`,
              },
              {
                name: 'Exams',
                text: `
                  <p>Exams are ideal for students to gauge how much knowledge they’ve retained regarding theory and application from a given section or course. Passed exams demonstrate to potential employers that you possess the necessary expertise to perform your job well.</p>
                  <p><span class="highlight">365 Data Science</span> offers three types of exams.</p>
                  <ul>
                    <li><b>Optional practice exams</b> evaluate your understanding of a particular area or chapter of the course. They help you find potentially essential areas for improvement and are an excellent method to prepare for the course exams.</li>
                    <li><b>Course assessments</b> are thorough (timed) exams that gauge how much knowledge you have acquired on each course topic.</li>
                    <li><b>Career track exams</b> are accessible only once you have completed every course exam in the professional track and have had your knowledge accessed from every course in the career track.</li>
                  </ul>
                  <p><b>Simplilearn</b> offers quizzes, assessments, and—like 365 Data Science—certification exams for learners who wish to validate their skills and knowledge in data science. But note that some courses come only with certificates of completion without the need to pass an exam.</p>
                `,
              },
              {
                name: 'Certificates',
                text: `<p>Certification allows data science professionals to demonstrate their skills and knowledge to potential employers, clients, and peers. It validates that a professional has the necessary skills and expertise to perform the job at a high level. The certifications students receive from online learning platforms after completing a course or career track are key selling points.</p>
                      <p><span class="highlight">365 Data Science</span> provides industry-recognized certificates that significantly increase students’ chances of landing a data science job. When passing exams with a grade of at least 60%, students can acquire course certificates and career track certificates.</p>
                      <p>
                        <b>Simplilearn</b> offers various industry-recognized certificates for data science professionals. The Simplilearn certification requires learners to pass an exam that tests their knowledge and skills. But some of Simplilearn’s free courses offer certification upon completion without an exam.<br>
                        Traditional accrediting bodies or agencies do not accredit Simplilearn's data science certificates. But the platform is still well-respected and trusted by professionals and organizations worldwide. Simplilearn partners with various organizations and industry leaders—such as IBM, Microsoft, and the Data Science Council of America (DASCA)—to provide learners with certifications recognized in the industry.
                      </p>`,
              },
              {
                name: 'Q&A support',
                text: `
                <p><span class="highlight">365 Data Science</span> provides superb, personalized customer support, and instructors actively participate in responding to queries from the platform's Q&A section. Such assistance is essential for novices requiring professional guidance.</p>
                <p><b>Simplilearn</b> provides learners with 24/7 live chat and Q&A support—designed to promptly receive answers to questions and eradicate doubts about the course material. Learners can post their questions on the course forum, and the instructors or other learners can provide insights. This allows students to get various perspectives on the course material and clarify their understanding of complex topics.`,
              },
              {
                name: 'Student Ratings',
                text: `<p><span class="highlight">365 Data Science</span> and <b>Simplilearn</b> are well-regarded by students and have positive reviews on Trustpilot and G2. Simplilearn has an overall rating of 4.3/5 stars from 800 reviews on the G2 platform, while 365 Data Science has 4.6/5 based on 80 reviews.</p>
                <p>On Trustpilot, Simplilearn scores 4.5/5 from 16,000 reviews, and 365 Data Science boasts 4.9 stars out of 5, derived from 1,100 reviews.</p>
                <p>Most of Simplilearn’s negative reviews note technical problems and difficulties contacting customer support—even though 24/7 support is advertised on their platform. Such issues are rarely encountered on the 365 Data Science platform.</p>
                `,
              },
              {
                name: 'Pros and Cons',
                text: `
                <div class="title-dots-1">
                  <strong>Simplilearn</strong>
                </div>
                <div>Pros:</div>
                <ul class="dots">
                  <li>Flexible learning options, including self-paced and instructor-led courses</li>
                  <li>Hands-on projects and practical case studies</li>
                  <li>Personalized learning dashboard</li>
                </ul>
                <div class="spacing">Cons:</div>
                <ul class="dots">
                  <li>Outdated or noncomprehensive content</li>
                  <li>Difficulty getting refunds or accessing customer support</li>
                  <li>Technical issues with the platform</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science</div>
                <div class="title-dots-2">Pros:</div>
                <ul class="dots">
                  <li>Comprehensive data science program encompassing a wide range of topics</li>
                  <li>Hands-on projects and practical case studies</li>
                  <li>Gamified learning platform</li>
                  <li>Access to Q&A support and a dedicated support team</li>
                </ul>
                <div>Cons:</div>
                <ul class="dots">
                  <li>No live lectures or bootcamps</li>
                  <li>No 1-on-1 mentorship</li>
                </ul>
                `,
              },
              {
                name: 'Pricing',
                text: `
                <p><span class="highlight">365 Data Science</span> provides free content to students who wish to taste the platforms’ teaching styles before deciding on a plan. It allows students access to the first lessons of each course and the resources and practice exams in them. In this way, students have an excellent opportunity to upgrade.</p>
                <p><b>Simplilearn</b> does not offer a free plan but allows learners to access some of its courses for free via its Free Resources section, which includes free courses, webinars, articles, and eBooks that present various topics like digital marketing, data science, cloud computing, and more.</p>
                <div class="highlight-text"><b>Simplilearn Pricing</b></div>
                <ul class="dots">
                  <li><b>Free:</b> Self-paced beginner courses</li>
                  <li><b>Self-paced learning courses:</b> $399–$999</li>
                  <li><b>Blended learning courses:</b> $699–$3,499</li>
                  <li><b>Live online classes:</b> $999–$4,999</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Data Science Pricing</div>
                <ul class="dots">
                  <li><b>Free subscription:</b> access to the first few lessons of all courses</li>
                  <li><b>Premium:</b> $36/month or $29/month billed annually</li>
                </ul>`,
              },
            ],
          },
          thirdSection: {
            title: 'Pricing: 365 Data Science vs Simplilearn',
            text: `<p><b>365 Data Science</b> is ideal for novice and intermediate learners. Its curriculum provides a solid foundation, covering essential business principles, programming languages like SQL, R, Python, and Excel, and data visualization tools like Tableau.</p>
            <p><b>Simplilearn</b> offers flexible, self-paced, and instructor-led courses in cybersecurity, digital marketing, business analytics, cloud computing, project management, AI, and more—making it an ideal learning platform for professionals and beginners seeking to upskill in tech.</p>`,
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoSimplilearn',
              planType: 'Self-paced learning courses',
              price: '$399–$999',
              pricePer: 'per program',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real environment practice',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Data Science vs Simplilearn: Which one to choose?',
            text: `<p><b>Simplilearn</b> offers self-paced and blended learning and live online classes, while 365 Data Science provides structured career tracks and individual self-paced courses.</p>
            <p>Simplilearn’s courses feature tech-related topics and vary in price. But its data science training program is not as well-structured as 365’s comprehensive platform.</p>
            <p>If you’re looking for a specialized program to build your skills from the ground up in data analytics, machine learning, and programming, the <b>365 Data Science</b> curriculum is the right choice. Each career track explains concepts in an easy-to-understand manner, incorporating all the necessary technologies and skills while emphasizing practical skills. At the end of the career track, you can acquire an industry-recognized certificate to prove your proficiency—affording you an advantage over other job applicants. 
            <span class="highlight">365 Data Science</span> is a better choice than Simplilearn for data science. But if you wish to learn software development or digital marketing, Simplilearn might be the more suitable option. </p>`,
          },
        },
        '/cfi-365-financial-analyst/': {
          competitorName: 'CFI',
          heroSection: {
            title: 'CFI Alternative: 365 Financial Analyst vs Corporate Finance Institute',
            subtitle: 'Course Content, Features, Pricing: Why 365 Financial Analyst Brings More Value to Novice Finance Students',
            description: 'Corporate Finance Institute (CFI) is an esteemed online platform acknowledged by prominent financial institutions, delivering comprehensive courses in corporate finance, financial modeling, valuation, and related subjects. Their self-paced programs equip finance professionals and students with practical skills. In contrast, 365 Financial Analyst offers various courses and certifications, including financial analysis, accounting, financial modeling, investment banking, corporate finance, and portfolio management. Their curriculum caters to finance professionals, students, and beginners seeking foundational knowledge, showcasing a distinct value proposition compared to CFI\'s program.',
          },
          firstSection: {
            title: 'Course Content: 365 Financial Analyst vs CFI',
            text: `<p><strong>365 Financial Analyst</strong> is ideal for novice and intermediate learners. The curriculum provides a solid foundation, covering various essential topics, such as financial statement analysis, financial modeling, valuation, corporate finance, accounting, investment banking, etc.</p>
                  <p><strong>CFI</strong> is for finance professionals and students looking to upskill and become accredited. It offers financial education in various topics for diverse experience levels but is more geared toward intermediate and advanced learners.</p>`,
            subtitle: '365 Financial Analyst',
            dataScienceText: `<p>The 365 Financial Analyst program offers self-paced courses, which include video lectures, exercises, quizzes, and case studies. It suits learners of all levels, from beginners to advanced professionals. The program offers three career tracks: Financial Analyst, Investment Analyst, and Investment Banker. The career tracks are designed to guide learners through a series of courses to develop the skills and knowledge required for specific career paths in finance. Students can take individual courses to obtain certification in selected topics and complete the full career tracks to get certified in their chosen career path.</p>
            <p>The courses cover various topics, including ratio analysis, equity and fixed-income securities, FP&A, valuation, portfolio management, and diverse data analysis and visualization tools like Excel, PowerPoint, Power BI, and Tableau. Тhe 365 Financial Analyst program offers multiple practical exercises, case studies with real-world financial scenarios, quizzes, exams, and a gamified platform to create a motivating and engaging learning experience.</p>`,
            dataScienceImage: 'data-camp-img1-fa.jpg',
            dataScienceImageAlt: 'Screenshot from 365 Data Science’s learning platform displaying part of its course content.',
            dataScienceImageTitle: '365 Data Science Learning Platform',
            competitorText: `<p>CFI offers certification programs, individual courses, and specializations, including Business Essentials, Business Intelligence Analyst, Commercial Real Estate Finance, Cryptocurrencies and Digital Assets, Data Analysis in Excel, and Environmental, Social & Governance (ESG). Each includes a set of courses that build on each other and teach skills relevant to a chosen career path.</p>
            <p>The CFI training consists of courses, assessments, practice exercises, and case studies with real-world applications. They offer a Practice Lab that provides learners various exercises and simulations to practically apply concepts and techniques learned in the courses. CFI‘s lab also includes video tutorials, sample models, and case studies to enhance learners' skills and apply them to their work or projects.</p>
            <p>Both 365 Financial Analyst and Corporate Finance Institute offer comprehensive financial training programs covering financial modeling, valuation, accounting, data analysis, business essentials, etc. And while CFI provides a slightly richer library of courses and specializations, 365 Financial Analyst’s curriculum is more suitable for beginners—a better choice if you’re new to finance.</p>`,
            competitorImage: 'cfi.jpg',
            competitorImageAlt: 'Screenshot from CFI’s learning platform displaying part of its course content.',
            competitorImageTitle: 'CFI Learning Platform',
            competitorSubTitle: '',
            competitorList: '',
            competitorSubtext: '',
            subText: '',
          },
          secondSection: {
            title: 'Key Features',
            list: [
              {
                name: 'Learning Platform',
                text: `<p><span class="highlight">365 Financial Analyst</span> provides comprehensive and practical financial education. The platform's curriculum equips learners with the skills and knowledge to excel in various roles, such as financial analyst, investment banker, or investment analyst. The 365 Financial Analyst courses are structured, easy to understand, and highly beginner-friendly.</p>
                <p>The learning platform includes gamified features that encourage and motivate students—making the learning experience more enjoyable and engaging. Students can earn XPs and collect cards featuring portraits of notable figures in finance. They can also set goals, track their progress on a dashboard, compete with other students to reach the top of the leaderboard, communicate via a newsfeed, and receive rewards and benefits.</p>
                <p><b>CFI</b> provides learners with practical skills and knowledge through its comprehensive curriculum and helpful resources to excel in various financial industry roles. But it doesn’t have 365 Financial Analyst's gamification elements and engaged student community, which creates a sense of responsibility and competition that motivates learners to continue their education without giving up.</p>`,
              },
              {
                name: 'Learning Material',
                text: `<p><span class="highlight">365 Financial Analyst's</span> courses include engaging video lessons with supplementary downloadable study materials, exercises, and case studies with real-life applications. In addition, the platform offers the following free downloadable resources you can store on your computer and access offline.</p>
                <ul>
                  <li>Finance data: free Excel files with historical price information related to S&P 500, commodities, and cryptocurrencies.</li>
                  <li>Templates and models: ready-made and easy-to-use financial Excel templates, models, and formula sheets.</li>
                  <li>Infographics: eye-catching graphics that make newcomers’ learning experience and professional development journey more straightforward and enjoyable.</li>
                  <li>Practice exams: free exams to practice and test your skills.</li>
                  <li>Free guides and tutorials: downloadable PDF documents and step-by-step guides on various finance topics.</li>
                </ul>
                <p><b>CFI</b> provides learners with downloadable study material—including PDFs with course notes, Excel files with financial models and templates, PowerPoint presentations, case studies, and quizzes. These resources may vary depending on the course or program and can be accessed from the learner's account and downloaded for offline use.</p>`,
              },
              {
                name: 'Practical Case Studies',
                text: `<p><span class="highlight">365 Financial Analyst</span> allows learners to practice with real-world case studies and examples. Students are presented with real financial scenarios and must use the knowledge and skills gained in the lessons. They can also build their own financial models based on actual financial statements. This approach provides students with practical experience and helps them develop their critical thinking and problem-solving skills in a safe and controlled environment.</p>
                <p><b>CFI</b> offers a Practice Lab that allows learners to practice their skills and knowledge. The lab provides access to actual financial models used by analysts and investment bankers, and learners can build their own models and work with different financial statements. It also features a range of resources, including video tutorials, sample models, and case studies to help learners develop their skills. The lab is accessible 24/7 and allows learners to track their progress and performance.</p>
                <p>Both platforms provide learners an effective and engaging way to develop the skills needed to succeed in finance.</p>`,
              },
              {
                name: 'Exams',
                text: `
                  <p>Exams are a valuable tool for students to evaluate their comprehension and application of theoretical concepts in a particular section or course. Passing these assessments shows prospective employers that you have the required knowledge and skills to excel in your role.</p>
                  <p><span class="highlight">365 Financial Analyst</span> offers the following three types of exams.</p>
                  <ul>
                    <li><b>Practice exams:</b> These non-mandatory exams allow learners to assess their comprehension of a specific section or topic covered in the course. They enable students to identify areas needing improvement and are helpful tools for exam preparation.</li>
                    <li><b>Course assessments:</b> aThese (timed) exams comprehensively test your knowledge and understanding of each course topic.</li>
                    <li><b>Career track exams:</b> These are available only upon completing all course exams within the professional track and after your knowledge has been evaluated from all courses within the career track.</li>
                  </ul>
                  <p>The <b>CFI</b> training includes several exams to evaluate and test learners' understanding of the course material—including optional practice exams, course assessments, certification exams, and learning path exams. The optional practice exams are designed to evaluate a student’s understanding of a particular area or chapter of the course. In contrast, the course assessments are thorough, timed exams that gauge how much knowledge students have acquired on each course topic. Certificate assessments are also the final exams for each course and must be passed to earn a CFI certification.</p>
                  <p>Both platforms have practice exams to test students’ understanding of the course material and learning path/career track exams to earn certificates. But CFI provides more extensive and challenging exams for its certification programs, which require a passing grade of 80% or higher.</p>
                `,
              },
              {
                name: 'Certificates',
                text: `<p>Earning a certificate from an online learning platform after completing a course or career track is valuable for finance professionals. Certification affirms that a professional has the required skills and knowledge to perform their job at a high level. It’s a means of proving their expertise and capabilities to employers, clients, and colleagues.</p>
                      <p><span class="highlight">365 Financial Analyst</span> offers certificates recognized by the industry, and acquiring these certificates can increase the likelihood of finding a job in finance. Students can receive course certificates and career track certificates by passing exams with a minimum score of 60%.</p>
                      <p>
                        <b>CFI</b> offers course certificates, program certificates, and professional designations upon completing specific certification exams. The course certificates are issued upon completing individual courses, while the program certificates are awarded upon completing all courses within a particular program. On the other hand, professional designations require the completion of multiple career tracks and passing the corresponding exams.
                      </p>
                      <p>365 Financial Analyst and CFI offer certificates of achievement that demonstrate learners’ knowledge and skills to potential employers.</p>
                      <p>An official accrediting body does not accredit the CFI certification. But CFI has a strong reputation in the finance industry, and many employers and professionals recognize and respect its certificates.</p>
                    `,
              },
              {
                name: 'Q&A support',
                text: `
                <p><span class="highlight">365 Financial Analyst</span> offers exceptional customer service personalized to individual needs. The platform instructors promptly answer questions in the Q&A section, which is helpful for beginners and those seeking professional guidance. <b>CFI</b> provides a help center with FAQs, a chat support feature for real-time assistance, and email support. Additionally, learners can schedule one-on-one sessions with an expert tutor for personalized help.</p>`,
              },
              {
                name: 'Student Ratings',
                text: `<p><span class="highlight">365 Financial Analyst</span> and <b>Corporate Finance Institute</b> are well-regarded by students and have positive reviews on Trustpilot. CFI has an overall rating of 4.9/5 stars based on over 600 reviews on the Trustpilot platform, while 365 Financial Analyst has 4.5/5 from 15 reviews.</p>
                      <p>365 is an established provider of courses in several niches with over 3 million students and a stellar reputation for content satisfaction and learning style.</p>
                      `,
              },
              {
                name: 'Pros and Cons',
                text: `
                <div class="title-dots-1">
                  <strong>CFI</strong>
                </div>
                <div>Pros:</div>
                <ul class="dots">
                  <li>Extensive course catalog covering various topics in finance and accounting</li>
                  <li>Real-world case studies and examples of applying theoretical knowledge to practical situations</li>
                  <li>Recognized certification</li>
                </ul>
                <div class="spacing">Cons:</div>
                <ul class="dots">
                  <li>No free plan</li>
                  <li>Expensive</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Financial Analyst</div>
                <div class="title-dots-2">Pros:</div>
                <ul class="dots">
                  <li>Structured, engaging, and beginner-friendly training on various finance topics</li>
                  <li>Real-world examples and exercises to apply learned concepts</li>
                  <li>Gamified features to increase engagement</li>
                  <li>Affordable price</li>
                </ul>
                <div>Cons:</div>
                <ul class="dots">
                  <li>No dedicated mobile app</li>
                  <li>No one-on-one mentorship</li>
                </ul>
                `,
              },
              {
                name: 'Pricing',
                text: `
                <p><span class="highlight">365 Financial Analyst</span> provides free access to a portion of its course content—allowing students to experience the teaching approach before committing to a paid plan. Students have access to the first lessons of every course and their related resources, including practice exams. This approach allows students to decide about upgrading to a paid plan.</p>
                <p><b>CFI</b> does not offer a free plan but provides some free resources, such as free courses, guides, and articles on its website. They also offer a free trial for their paid courses, allowing users to access limited course materials for a fixed time.</p>
                <div class="highlight-text"><b>CFI Pricing</b></div>
                <ul class="dots">
                  <li><b>Self-study:</b> $497/year</li>
                  <li><b>Full-Immersion:</b> $847/year</li>
                </ul>
                <div class="highlight" class="highlight-text">365 Financial Analyst Pricing</div>
                <ul class="dots">
                  <li><b>Free subscription:</b> access to the first few lessons of all courses</li>
                  <li><b>Premium:</b> $36/month or $29/month billed annually</li>
                </ul>`,
              },
            ],
          },
          thirdSection: {
            title: '365 Financial Analyst vs CFI: An Overview',
            text: `<p><b>365 Data Science</b> is ideal for novice and intermediate learners. Its curriculum provides a solid foundation, covering essential business principles, programming languages like SQL, R, Python, and Excel, and data visualization tools like Tableau.</p>
            <p><b>Simplilearn</b> offers flexible, self-paced, and instructor-led courses in cybersecurity, digital marketing, business analytics, cloud computing, project management, AI, and more—making it an ideal learning platform for professionals and beginners seeking to upskill in tech.</p>`,
            dataSciencePrice: '$15.33',
            planHead: {
              logo: 'LogoCFI',
              planType: 'Self-Study',
              price: '$41.42',
            },
            featuredPlans: [
              {
                name: 'Online On-demand Video ',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Gamifield Platform',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Comprehensive Portfolio',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Free Plan',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Step-by-Step Curriculum',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Real-World Case Studies',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Personalized learning dashboard',
                dataScience: true,
                competitor: true,
              },
              {
                name: 'Career tracks',
                dataScience: true,
                competitor: false,
              },
              {
                name: 'Exams',
                dataScience: true,
                competitor: true,
              },
            ],
          },
          fourthSection: {
            title: '365 Financial Analyst vs CFI: Which One to Choose?',
            text: `<p>Choosing between 365 Financial Analyst and CFI depends on personal preferences and goals.</p>
            <p><b>365 Financial Analyst</b> may be a better fit for those seeking an engaging learning experience with a strong focus on practical skills. The platform's gamified approach and community of engaged learners can provide a sense of accountability and motivation to stay on track.</p>
            <p>On the other hand, <b>CFI</b> may be a better fit for those who prefer a more traditional approach to learning with a focus on theory and professional accreditation. CFI's courses are designed to cover a broad range of topics and provide a comprehensive understanding of finance concepts. Its certification is widely recognized in the industry.</p> 
            <p><span class="highlight">365 Financial Analyst</span> is better for beginners due to its more beginner-friendly approach, individualized support, and emphasis on practical skills. The platform provides a step-by-step curriculum, personalized feedback, and real-world practice to help beginners gain a strong foundation in finance. The free content offered by 365 is an excellent opportunity to try the platform before committing to a paid plan. Overall, 365 is the more affordable finance training provider.</p>`,
          },
        },
      },
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [{ rel: 'canonical', href: this.canonicalURL() }],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  created() {
    this.page = this.seo;
    this.page.fullPath = `${this.$config.siteUrl}${this.$route.fullPath}`;
    this.page.data = this.data[this.$route.path];

    if (this.page.prices) {
      let price = this.page.prices.price / 12;
      if (this.page.prices.currency) {
        price = this.$options.filters.formatCurrency(price, this.page.prices.currency, { minimumFractionDigits: 0 });
      } else {
        price = `$${price.toFixed(2)}`;
      }
      this.page.data.thirdSection.dataSciencePrice = price;
    }
  },
  methods: {
    getCompetitorImage(competitorImage) {
      return require(`../assets/images/${competitorImage}`);
    },

    getDataScienceImage(dataScienceImage) {
      return require(`../assets/images/${dataScienceImage}`);
    },
    subscribe() {
      this.$router.push('/checkout/?plan=annual&coupon=OTH20DQT20NW4');
    },
  },
};
</script>

<style lang="scss" scoped >
.alternative-page {
  ::v-deep(.highlight) {
    font-weight: 700;
    color: var(--accent-shade-2);
  }

  ::v-deep(.shade-light) {
    color: var(--main-dark-shade-4);
  }

  .site-section {
    display: flex;
    padding-bottom: var(--spacing-120);
    padding-top: var(--spacing-120);

    @include bp($bp-phone) {
      padding-bottom: var(--spacing-80);
      padding-top: var(--spacing-80);
    }
  }

  .highlight,
  .title {
    margin-bottom: var(--spacing-8);
  }

  .top-section {
    .container {
      align-content: center;
      align-items: center;
      display: flex;
      text-align: center;
      position: relative;
      z-index: 5;

      .h2,
      .h3 {
        color: var(--true-white);
        margin-bottom: var(--spacing-16);
      }
    }

    &.hero-section {
      min-height: 650px;
      position: relative;
      width: 100%;
      background-color: var(--main-dark);

      .wall {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: url('../assets/images/alternative-page.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        filter: blur(5px);
      }

      &:before {
        content: "";
        image-rendering: -webkit-optimize-contrast;
        position: absolute;
        background: radial-gradient(42.96% 95.23% at 50% 50%, #25F4EE 0%, #27F4EE 24.48%, #141F31 100%, #141F31 100%);
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
      }

      .shadow {
        position: absolute;

        &.l-shadow {
          background: linear-gradient(90deg, rgba(0, 12, 31, 0.94) 0%, rgba(0, 12, 31, 0.94) 0.01%, rgba(0, 12, 31, 0.9) 47.67%, rgba(0, 12, 31, 0) 100%);
          height: 100%;
          top: 0;
          left: 0;
          width: 318.5px;
        }

        &.r-shadow {
          background: linear-gradient(90deg, rgba(0, 12, 31, 0.9) 0%, rgba(0, 12, 31, 0.94) 0.01%, rgba(0, 12, 31, 0) 100%);
          height: 100%;
          top: 0;
          right: 0;
          transform: rotate(-180deg);
          width: 304.5px;
        }

        &.u-shadow {
          background: linear-gradient(180deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
          width: 100%;
          height: 110px;
          left: 0;
          top: 0;
        }

        &.d-shadow {
          background: linear-gradient(180deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
          transform: rotate(-180deg);
          height: 200px;
          bottom: 0;
          right: 0;
          width: 100%;
        }
      }

      .container {
        min-height: 650px;

        .body-1 {
          color: var(--main-light-shade-2);
          margin-bottom: var(--spacing-16);
          font-size: 18px;
        }

        .body-2 {
          color: var(--main-dark-shade-4);
        }
      }

      @include bp($bp-phone) {
        &:before {
          background-position: top 68px center;
          background-size: auto 254px;
          min-height: auto;
          opacity: 1;
        }

        .h2 {
          margin-top: var(--spacing-80);
        }

        .container {
          min-height: auto;
          padding-top: var(--spacing-80);
          padding-bottom: var(--spacing-80);
          text-align: left;
        }
      }
    }

    &.site-section {
      padding-bottom: var(--spacing-120);
      padding-top: var(--spacing-100);

      .body-2 {
        color: var(--main-dark-shade-4);
      }

      .col-12 {
        max-width: 990px;
      }
    }

    &.competitor:after {
      content: '';
      background-color: var(--main-dark);
      opacity: 0.8;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    &.dataquest:before {
      background-image: url('../assets/images/dataquest.jpg');
    }
  }

  .science-vs-competitor {
    .h3 {
      margin-bottom: var(--spacing-80);
      display: flex;
      justify-content: center;
    }

    .first-title {
      margin-bottom: var(--spacing-16);
    }

    .image {
      box-shadow: 0 16px 24px rgba(0, 12, 31, 0.08);
      border-radius: 10px;
      width: 100%;
      max-height: 568px;
      margin: 0 auto var(--spacing-80);
    }

    .image-2 {
      margin: 0 auto var(--spacing-32);
    }

    .strong {
      font-weight: 600;
    }

    ol {
      counter-reset: custom-counter;
      list-style: none;
      padding-left: var(--spacing-32);
      margin-bottom: var(--spacing-32);

      li {
        counter-increment: custom-counter;
        position: relative;
        padding-left: var(--spacing-16);

        &:before {
          content: counter(custom-counter);
          left: 0;
          position: absolute;
        }
      }
    }

    .ready-to-learn {
      border-radius: 7px;
      margin-top: var(--spacing-80);
      padding: 0;
      text-align: center;

      h4 {
        color: var(--main-light);
        margin-bottom: var(--spacing-12);
      }

      .body-2 {
        color: rgba(255, 255, 255, 0.67);
        margin-bottom: var(--spacing-36);
      }

      .btn-primary {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        margin: 0 auto;
        height: 58px;
        width: 100%;
        max-width: 300px;
      }
    }

    .section-white {
      .sm-order-3 {
        margin-top: var(--spacing-48);
      }

      .holder-button {
        margin-top: 0;
      }

      ::v-deep {
        .small-subtitle {
          font-size: 21px;
        }

        .list {
          margin-left: 30px;
        }
      }
    }

    @include bp($bp-phone) {
      .h3 {
        margin-bottom: var(--spacing-16);
        font-size: 32px;
        line-height: 110%;
        font-weight: 500;
      }

      .section-white {
        .h3 {
          margin-bottom: var(--spacing-32);
          text-align: center;
          margin-top: var(--spacing-100);
          font-size: 24px;
        }

        .h5 {
          margin-bottom: var(--spacing-8);
        }

        .image {
          margin: var(--spacing-32) auto var(--spacing-80);
        }

        .sm-order-3 {
          margin-top: 0;
        }
      }

      img {
        margin: var(--spacing-24) auto var(--spacing-32);
      }

      .sm-order-1 {
        order: 1;
      }

      .sm-order-2 {
        order: 2;
      }

      .sm-order-3 {
        order: 3;

        p:last-of-type {
          margin-bottom: 0;
        }
      }

      .ready-to-learn {
        margin-top: 0;
        padding: 0;

        .btn-primary {
          width: 100%;
          max-width: 100%;
          height: 58px;
        }
      }
    }
  }

  .auxiliary-services {
    .h3 {
      margin-bottom: var(--spacing-60);
    }

    .col-12 {
      margin-bottom: var(--spacing-lg);

      &:last-of-type {
        margin-bottom: 0;
      }

      .h4 {
        margin-bottom: var(--spacing-12);
        padding-left: 27px;
        position: relative;
        text-transform: capitalize;

        &:before {
          background-color: var(--accent);
          content: "";
          position: absolute;
          width: 8px;
          height: 8px;
          top: 9px;
          left: 0;
        }
      }

      .body-2 {
        color: var(--main-dark-shade-4);

        ::v-deep {
          ul {
            list-style-position: outside;
          }

          .highlight {
            color: var(--accent);
          }

          .dots {
            margin: var(--spacing-12) 0;
            margin-left: 2px;
            list-style-position: outside;
            padding: 0;
            padding-left: var(--spacing-26);
            margin-bottom: var(--spacing-24);

            &:last-of-type {
              margin-bottom: var(--spacing-4);
            }
          }

          .finish {
            margin-bottom: 0;
          }

          .title-dots-1 {
            margin-bottom: var(--spacing-12);
          }

          .title-dots-2 {
            margin-top: var(--spacing-12);
          }

          .highlight-text {
            margin-top: var(--spacing-24);
          }
        }
      }
    }

    @include bp($bp-mobile) {
      .h3,
      .h4 {
        font-size: 24px;
      }

      .col-12 {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  .white {
    background: var(--main-light-shade-1);

    .h3 {
      margin-bottom: var(--spacing-80);
      text-align: center;
    }
  }

  .pre-footer {
    ::v-deep {
      .container .h2 {
        font-size: 32px;
      }

      .subtitle {
        width: 100%;
      }

      .row-btn {
        .btn-lg {
          width: 100%;
        }
      }
    }
  }

  @include bp($bp-mobile) {
    .white {
      .h3 {
        font-size: 24px;
        margin-bottom: var(--spacing-16);
      }
    }

    .pre-footer {
      ::v-deep {
        .container .h2 {
          font-size: 28px;
        }
      }
    }
  }

  @include bp($bp-phone) {
    .pre-footer {
      ::v-deep {
        .subtitle {
          margin-bottom: var(--spacing-44);
        }

        .row-btn {
          display: flex;
          justify-content: center;

          .btn-lg {
            width: 100%;
          }
        }
      }
    }
  }

  .pricing-plans {
    padding-top: var(--spacing-80);
    padding-bottom: var(--spacing-120);

    .section-inner {
      justify-content: center;
    }

    .pricing-plan {
      border-radius: 10px;

      .plan-head {
        padding: var(--spacing-90) 28px 42px;
        position: relative;
        text-align: left;

        .logo:not(.edx) {
          position: absolute;
          left: 28px;
          top: 32px;

          path {
            fill: var(--main-dark-light-4);
          }
        }

        .logo-2:not(.edx) {
          path {
            fill: var(--main-light-shade-4);
          }
        }

        .logo.edx {
          position: absolute;
          left: 28px;
          top: 32px;
        }

        .premium {
          color: var(--accent-shade-1);
        }

        h2 {
          margin-top: var(--spacing-12);
          margin-bottom: var(--spacing-16);

          .highlight {
            margin-bottom: var(--spacing-8);
          }

          sup {
            font-size: 18px;
            line-height: 110%;
            text-decoration: line-through;
          }

          span {
            font-weight: 400;
          }
        }

        .caption {
          color: var(--main-light-shade-4);
        }

        .btn-primary {
          margin-top: var(--spacing-12);
          width: 100%;
        }
      }

      &.plan-datascience {
        background-color: var(--main-dark);
        color: var(--true-white);
      }

      &.plan-competitor {
        background-color: var(--main-light-shade-2);
        color: var(--main-dark);
        align-items: flex-start;

        .plan-head {
          color: var(--main-dark-light-3);
          padding-bottom: 110px;

          .caption {
            color: var(--main-dark-light-3);
          }
        }

        .plan-features {
          .feature {
            &:last-child:after,
            &:before {
              left: -16px;
              width: calc(100% + 16px);
            }
          }
        }
      }

      .plan-features {
        position: relative;
        padding-left: var(--spacing-32);
        padding-right: var(--spacing-32);
        padding-bottom: var(--spacing-24);
        margin: 0;

        .feature {
          list-style: none;
          text-align: left;
          line-height: 36px;
          font-weight: 400;
          padding: 30px 0;
          position: relative;
          height: 48px;
          margin: 0;

          &.type {
            color: var(--main-dark-light-2);
          }

          svg {
            margin-right: var(--spacing-12);
          }
        }
      }

      .plan-secondary-features {
        margin-top: 80px;
      }

      &.plan-index {
        width: calc(100% - 728px);

        ul {
          &:before {
            position: absolute;
            top: -38px;
            font-weight: 500;
            font-size: var(--fs-medium);
            width: 160px;
            color: var(--main-dark);
          }

          .feature {
            text-align: left;
          }

          &.plan-secondary-features {
            &:before {
              content: "Career Support";
            }
          }
        }
      }
    }

    @include bp($bp-mobile) {
      padding-top: var(--spacing-60);
      padding-bottom: var(--spacing-60);
      margin: auto;
      display: table;

      .pricing-plan {
        width: 100%;
        margin-left: 0;
        margin-right: 0;

        h2 {
          font-size: 40px;
        }

        &.plan-datascience {
          margin-bottom: var(--spacing-16);
          margin-right: 0;
          max-width: 100%;

          .plan-features {
            .feature {
              &:last-child:after,
              &:before {
                left: 0;
                width: 100%;
              }

              .feature-label {
                &.active {
                  color: var(--main-light);
                  left: 28px;
                  line-height: 150%;
                }
              }
            }
          }
        }

        &.plan-competitor {
          max-width: 100%;
          margin-right: 0;

          .plan-head {
            padding-bottom: 38px;
          }

          .plan-features {
            .feature {
              &:last-child:after,
              &:before {
                left: 0;
                width: 100%;
              }

              .feature-label {
                margin-left: 28px;
                color: var(--main-dark-shade-0);
                line-height: 150%;
              }
            }
          }
        }

        .plan-features {
          .feature {
            .feature-label {
              display: flex;
              position: absolute;
              left: var(--spacing-35);
              top: 6px;
              line-height: 38px;
            }

            svg {
              position: absolute;
              right: var(--spacing-32);
              top: 30%;
              transform: translateY(-50%);
              left: 0;
            }
          }
        }
      }

      .plan-index {
        display: none;
      }

      .section-inner {
        display: block;
      }
    }

    @include bp($bp-phone) {
      display: block;
    }
  }

  @include bp($bp-laptop) {
    .site-section .section-white .col-6 {
      .image {
        margin: 0;
      }

      &.sm-order-1,
      &.sm-order-2 {
        margin-top: var(--spacing-80);
      }

      &:has(.image) {
        display: flex;
        align-items: center;
      }
    }

    .pre-footer {
      ::v-deep {
        .container .row-btn {
          max-width: 320px;
        }
      }
    }
  }

  .title {
    color: var(--main-dark-light-4);
  }

  .vs {
    padding-bottom: var(--spacing-80);
    padding-top: var(--spacing-80);

    .h3 {
      margin-bottom: var(--spacing-16);
    }

    .body-2 {
      color: var(--main-dark-shade-4);
    }
  }
}

.fa {
  .alternative-page {
    .highlight {
      color: var(--accent-shade-1);
      font-weight: 500;
    }

    .top-section.hero-section:before {
      background: radial-gradient(42.96% 95.23% at 50% 50%, #036FFD 0%, #036FFD 24.48%, #141F31 100%, #011633 100%);
    }

    .pricing-plans .pricing-plan.plan-competitor {
      background-color: var(--main-light-shade-3);
    }

    .pricing-plans .pricing-plan:not(.plan-competitor) {
      .plan-head .premium {
        color: var(--accent);
      }
    }
  }
}
</style>
